import { useConfirmModal } from "../pages/ConfirmModalContext";
import React, { useState, useEffect, useRef, useCallback } from "react";
import Logo from "../images/Infomanav.svg";
import LogoApple from "../images/company-logos/apple.svg";
import LogoIgne from "../images/company-logos/igne.svg";
import LogoTesla from "../images/company-logos/tesla.svg";
import LogoJNJ from "../images/company-logos/jnj.svg";
import { SelectPicker, Message, Whisper, Tooltip } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { motion, AnimatePresence } from "framer-motion";
import 'rsuite/SelectPicker/styles/index.css';
import ArrowTrendUp from "../images/arrow-trend-up.svg";
import ArrowTrendDown from "../images/arrow-trend-down.svg";
import { toast } from "react-toastify";
import "../css/style.css"
import { useNavigate } from 'react-router-dom';
import Loader2 from "./Loader2"
import { IoClose } from "react-icons/io5";
import MarketDepthIcon from "./MarketDepthIcon";
import DeleteLogo from "../images/DeleteLogo.svg";
import FivePaisaLogo from "../images/5PaisaLogo.svg";
import GrowwLogo from "../images/growwLogo.svg";
import AngelOneLogo from "../images/Angel_One_Logo.png";
import { UserRound } from "lucide-react";
import MarketBanner from "../pages/MarketBanner";
import { CgProfile } from "react-icons/cg";
import { FaPowerOff } from "react-icons/fa";
import { FaHeartCirclePlus } from "react-icons/fa6";
import MarketStatusIndicator from "./MarketStatusIndicator";
import "../css/Header.css"
import {
  LANGUAGE_OPTIONS,
  getCurrentLanguage,
  setCurrentLanguage,
  t,
} from "../i18n";
import fivePaisaWebSocketService from "../services/fivePaisaWebSocketService";
import angelOneWebSocketService, {
  buildAngelInstrumentFields,
  getAngelExchangeTypeFromHolding,
} from "../services/angelOneWebSocketService";
import fivePaisaMarketDepthStore from "../services/fivePaisaMarketDepthStore";
import {
  placeOrderViaPms,
  normalizePlaceOrderResponse,
  isFivePaisaBroker,
  runPlaceOrderAcceptedFlow,
} from "../services/placeOrderService";
import growwLivePriceService from "../services/growwLivePriceService";
import { persistAuthSessionFromPayload } from "../services/authSessionService";
import { hydrateAllBrokerStatistics } from "../services/dashboardStatisticsService";
import { useBrokerStatisticsPolling } from "../hooks/useBrokerStatisticsPolling";
import { useBrokerStatisticsStore } from "../stores/brokerStatisticsStore";

const GROW_POLL_SOURCE = "headerSearch";

const Header = ({ tabName, setUpdateWatchlistTrigger, setProgress, activeTab3 }) => {
  const pmsApiBaseUrl =
    process.env.REACT_APP_PMS_API_BASE_URL || "https://pmsapi.infomanav.in";
  const [query, setQuery] = useState("");
  const [activeTab, setActiveTab] = useState("stocks");
  const [isActive, setIsActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // New state for search results
  const [searchResults, setSearchResults] = useState([]);


  const [isAddWatchlistDisabled, setIsAddWatchlistDisabled] = useState(false);
  const dropdownRef = useRef(null);
  const excludedButtonRef1 = useRef(null); // Ref for the button to exclude
  const excludedButtonRef2 = useRef(null); // Ref for the button to exclude


  // Add these new states and refs for WebSocket
  const [connected, setConnected] = useState(false);
  const [ws, setWs] = useState(null);
  const [liveUpdateTrigger, setLiveUpdateTrigger] = useState(0);
  const [subscribedStocks, setSubscribedStocks] = useState([]);
  const wsStatusUnsubRef = useRef(null);
  const wsPriceUnsubRef = useRef(null);
  const wsErrorUnsubRef = useRef(null);
  const angelWsStatusUnsubRef = useRef(null);
  const angelWsPriceUnsubRef = useRef(null);
  const angelWsErrorUnsubRef = useRef(null);

  const wsRef = useRef(null);
  const heartbeatIntervalRef = useRef(null);
  const connectionMonitorRef = useRef(null);
  const lastSubscribedHoldings = useRef([]);
  const subscribedScripCodes = useRef(new Set());
  // Market depth state (stores the latest order book for subscribed stock)
  const [marketDepth, setMarketDepth] = useState([]);
  const [currentMDModal, setcurrentMDModal] = useState(null);
  const [showMarketDepth, setShowMarketDepth] = useState(false);
  const [marketDepthPosition, setMarketDepthPosition] = useState({
    top: 0,
    left: 0,
  });
  const marketDepthButtonRef = useRef(null);
  const marketDepthPopoverRef = useRef(null);

  const [newWatchlistName, setNewWatchlistName] = useState('');
  const [watchlistError, setWatchlistError] = useState('');


  // Live price caches
  const livePriceCache = useRef({});
  const livePCloseCache = useRef({});
  const liveDiffCache = useRef({});
  const liveChangePercentageCache = useRef({});
  const liveVolumeCache = useRef({});
  const livePLCache = useRef({});
  const currentMDModalRef = useRef(null);
  const searchFeedSubscriptionRef = useRef([]);
  const growwSearchUnsubscribeRef = useRef(null);


  const [selectedStockToAdd, setSelectedStockToAdd] = useState(null);
  const [headerUserWatchlists, setHeaderUserWatchlists] = useState([]);
  const [headerWatchlistEntries, setHeaderWatchlistEntries] = useState([]);
  const [isLoadingWatchlists, setIsLoadingWatchlists] = useState(false);




  // Debounce timeout reference
  const debounceTimeout = useRef(null);

  const navigate = useNavigate();




  const sharedData = JSON.parse(localStorage.getItem("sharedData") || "null");
  const displayFirstName =
    sharedData?.First_Name || localStorage.getItem("first_name") || "";
  const brokerTypeRaw = String(
    localStorage.getItem("broker_type") || sharedData?.broker_type || "",
  ).toLowerCase();
  const isGrowBroker = brokerTypeRaw === "grow";
  const isAngelOneBroker = brokerTypeRaw === "angelone";

  const userBrokers = (() => {
    try {
      const parsed = JSON.parse(localStorage.getItem("user_brokers") || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  })();

  const brokersForDropdown =
    userBrokers.length > 0
      ? userBrokers
      : brokerTypeRaw
        ? [{ user_broker_id: "current", broker_flag: brokerTypeRaw }]
        : [];

  const getBrokerDisplay = (flag) => {
    const normalized = String(flag || "").toLowerCase();
    if (normalized === "grow") {
      return { name: "Groww", logo: GrowwLogo, isAngel: false };
    }
    if (normalized === "5paisa") {
      return { name: "5paisa", logo: FivePaisaLogo, isAngel: false };
    }
    if (normalized === "angelone") {
      return { name: "AngelOne", logo: AngelOneLogo, isAngel: true };
    }
    return { name: normalized || "Unknown", logo: null, isAngel: false };
  };

  const activeBrokerDisplay = getBrokerDisplay(brokerTypeRaw);

  const getOrderLivePriceCacheKey = (order) => {
    if (!order) return "";
    if (isAngelOneBroker) {
      return String(
        order?.Token || order?.token || order?.Scripcode || order?.ScripCode || "",
      ).trim();
    }
    if (order?.Exch === "N") {
      return order?.NseCode || order?.ScripCode || order?.Scripcode || "";
    }
    return order?.BseCode || order?.ScripCode || order?.Scripcode || "";
  };

  useEffect(() => {
    // Preload broker logos so header broker switcher shows instantly.
    [GrowwLogo, FivePaisaLogo, AngelOneLogo].forEach((src) => {
      if (!src) return;
      const img = new Image();
      img.src = src;
    });
  }, []);

  const statsByBroker = useBrokerStatisticsStore((state) => state.statsByBroker);
  useBrokerStatisticsPolling(pmsApiBaseUrl, brokerTypeRaw);

  const [buySellModalDetails, setBuySellModalDetails] = useState({
    FullName: '',
    Symbol: '',
    Type: 'Buy', // hardcoded for buy function, will create separate for sell
    OrderQty: 1, // default 1
    LimitPrice: 0, // default 0
    order: null // complete order object for future use
  });


  const [showDropdown, setShowDropdown] = useState(false);
  const [showBrokerDropdown, setShowBrokerDropdown] = useState(false);
  const dropdownRef2 = useRef(null);
  const brokerDropdownRef = useRef(null);
  const [currentLanguage, setCurrentLanguageState] = useState(getCurrentLanguage());

  const tr = useCallback(
    (key) => t(key, currentLanguage),
    [currentLanguage]
  );

  const SEARCH_BATCH_SIZE = 50;
  const SEARCH_LIMIT = 15;

  class BaseSearchAdapter {
    stringOrDefault = (value, fallback = "") =>
      value === null || value === undefined || value === "" ? fallback : String(value);

    normalizeRows = (rows = []) => rows;
  }

  class FivePaisaSearchAdapter extends BaseSearchAdapter {
    normalizeRows = (rows = []) =>
      rows
        .map((item = {}) => ({
          Scripcode: this.stringOrDefault(item?.ScripCode || item?.Scripcode),
          Exch: this.stringOrDefault(item?.Exch, "").charAt(0).toUpperCase(),
          ExchType: this.stringOrDefault(item?.ExchType, "C").charAt(0).toUpperCase(),
          Name: this.stringOrDefault(item?.Name || item?.Symbol, ""),
          Symbol: this.stringOrDefault(item?.Symbol || item?.Name, ""),
          FullName: this.stringOrDefault(item?.FullName, item?.Name || item?.Symbol || ""),
          ISIN: this.stringOrDefault(item?.ISIN, ""),
        }))
        .filter((item) => item.Scripcode && item.Exch && item.ExchType);
  }

  class GrowwSearchAdapter extends BaseSearchAdapter {
    normalizeRows = (rows = []) =>
      rows
        .map((item = {}) => {
          const exchangeRaw = this.stringOrDefault(item?.exchange, "NSE").toUpperCase();
          const exch = exchangeRaw.startsWith("B")
            ? "B"
            : exchangeRaw.startsWith("M")
              ? "M"
              : "N";
          const tradingSymbol = this.stringOrDefault(item?.trading_symbol, "");
          const exchangeToken = this.stringOrDefault(item?.exchange_token, "");
          // return {
          //   Scripcode: exchangeToken,
          //   Exch: exch,
          //   ExchType: "C",
          //   Name: tradingSymbol,
          //   Symbol: tradingSymbol,
          //   TradingSymbol: tradingSymbol,
          //   FullName: this.stringOrDefault(item?.name, tradingSymbol),
          //   ISIN: this.stringOrDefault(item?.isin, ""),
          // };
          return {
            Scripcode: exchangeToken,
            Exch: exch,
            ExchType: "C",
            Name: tradingSymbol,
            Symbol: tradingSymbol,
            TradingSymbol: tradingSymbol,
            FullName: this.stringOrDefault(item?.name, tradingSymbol),
            ISIN: this.stringOrDefault(item?.isin, ""),
          
            // 🔥 NEW: store OHLC (full object)
            OHLC: item?.stocks_data?.ohlc || null,
          
            // 🔥 OPTIONAL (useful shortcuts)
            PrevClose: Number(item?.stocks_data?.ohlc?.close) || 0,
          };
        })
        .filter((item) => item.Scripcode && item.Exch);
  }

  class AngelOneSearchAdapter extends BaseSearchAdapter {
    normalizeRows = (rows = []) =>
      rows
        .map((item = {}) => {
          const exchangeRaw = this.stringOrDefault(item?.exch_seg, "NSE").toUpperCase();
          const exch = exchangeRaw.startsWith("B")
            ? "B"
            : exchangeRaw.startsWith("M")
              ? "M"
              : "N";
          const fields = buildAngelInstrumentFields(item);

          return {
            Scripcode: this.stringOrDefault(item?.token, ""),
            Exch: exch,
            ExchType: fields.isDerivative ? "D" : "C",
            InstrumentName: fields.instrumentName,
            Name: fields.tradingSymbol,
            Symbol: fields.tradingSymbol,
            TradingSymbol: fields.tradingSymbol,
            tradingsymbol: fields.tradingSymbol,
            FullName: fields.fullName,
            Token: this.stringOrDefault(item?.token, ""),
            token: this.stringOrDefault(item?.token, ""),
            symboltoken: this.stringOrDefault(item?.token, ""),
            Expiry: fields.expiry,
            Strike: this.stringOrDefault(item?.strike, ""),
            LotSize: this.stringOrDefault(item?.lotsize, ""),
            InstrumentType: fields.instrumentType,
            ExchSeg: exchangeRaw,
            TickSize: this.stringOrDefault(item?.tick_size, ""),
          };
        })
        .filter((item) => item.Scripcode && item.Exch);
  }

  const getSearchAdapter = (brokerFlag) => {
    const normalizedFlag = String(brokerFlag || "").toLowerCase();
    if (normalizedFlag === "grow") return new GrowwSearchAdapter();
    if (normalizedFlag === "angelone") return new AngelOneSearchAdapter();
    if (normalizedFlag === "5paisa") return new FivePaisaSearchAdapter();
    return new BaseSearchAdapter();
  };

  const toBatches = (items = [], batchSize = SEARCH_BATCH_SIZE) => {
    const chunks = [];
    for (let index = 0; index < items.length; index += batchSize) {
      chunks.push(items.slice(index, index + batchSize));
    }
    return chunks;
  };

  const getGrowwPollingKey = (item = {}) => {
    const symbol = String(item?.Symbol || item?.Name || "").trim().toUpperCase();
    if (!symbol) return "";
    const exchangePrefix = item?.Exch === "B" ? "BSE" : item?.Exch === "M" ? "MCX" : "NSE";
    return `${exchangePrefix}_${symbol}`;
  };

  const resetSearchLiveCaches = () => {
    livePriceCache.current = {};
    livePCloseCache.current = {};
    liveDiffCache.current = {};
    liveChangePercentageCache.current = {};
    liveVolumeCache.current = {};
    livePLCache.current = {};
    setLiveUpdateTrigger((prev) => prev + 1);
  };

  const stopSearchLiveUpdates = () => {
    if (searchFeedSubscriptionRef.current.length) {
      if (isAngelOneBroker) {
        angelOneWebSocketService.unsubscribeMarketFeed(
          searchFeedSubscriptionRef.current,
        );
      } else {
        fivePaisaWebSocketService.unsubscribeMarketFeed(
          searchFeedSubscriptionRef.current,
        );
      }
      searchFeedSubscriptionRef.current = [];
    }
    growwSearchUnsubscribeRef.current?.();
    growwSearchUnsubscribeRef.current = null;
    growwLivePriceService.stopPolling(GROW_POLL_SOURCE);
  };

  useEffect(() => () => {
    stopSearchLiveUpdates();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef2.current && !dropdownRef2.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (brokerDropdownRef.current && !brokerDropdownRef.current.contains(event.target)) {
        setShowBrokerDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setCurrentLanguageState(event?.detail?.language || getCurrentLanguage());
    };
    window.addEventListener("app-language-change", handleLanguageChange);
    return () => window.removeEventListener("app-language-change", handleLanguageChange);
  }, []);

  const handleLanguageSelect = (value) => {
    if (value) setCurrentLanguage(value);
  };

  const handleChangePassword = () => {
    setShowDropdown(false);
    setIsLoading(true)
    setTimeout(() => {
      navigate('/ChangePassword');
      setIsLoading(false)
    }, 500);
  };

  const handleLogout = (e) => {
    setShowDropdown(false);
    setIsLoading(true)
    // e.preventDefault();
    if (e) e.preventDefault();
    setTimeout(() => {
      localStorage.removeItem("sharedData");
      useBrokerStatisticsStore.getState().reset();
      toast.success(tr("loggedOutSuccessfully"));
      navigate("/");
      setIsLoading(false)
    }, 1000);
  };

  const { showConfirm } = useConfirmModal();

const handleLogoutClick = () => {
  showConfirm({
    message: "Are you sure you want to logout?",
    onConfirm: handleLogout,
  });
};







  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10); // 50px scroll ke baad active
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    if (isGrowBroker || isAngelOneBroker) {
      return undefined;
    }

    wsStatusUnsubRef.current = fivePaisaWebSocketService.onStatus((status) => {
      setConnected(status?.type === "connected");
    });
    wsPriceUnsubRef.current = fivePaisaWebSocketService.onPrice((tick) => {
      handleLivePriceUpdate(tick);
    });
    wsErrorUnsubRef.current = fivePaisaWebSocketService.onError((error) => {
      console.error("❌ WebSocket error:", error);
    });

    fivePaisaWebSocketService.connect();
    return () => {
      wsStatusUnsubRef.current?.();
      wsPriceUnsubRef.current?.();
      wsErrorUnsubRef.current?.();
      wsStatusUnsubRef.current = null;
      wsPriceUnsubRef.current = null;
      wsErrorUnsubRef.current = null;
      fivePaisaWebSocketService.disconnect({ manual: false });
    };
  }, [isGrowBroker, isAngelOneBroker]);

  useEffect(() => {
    if (!isAngelOneBroker) {
      return undefined;
    }

    angelWsStatusUnsubRef.current = angelOneWebSocketService.onStatus((status) => {
      setConnected(status?.type === "connected");
    });
    angelWsPriceUnsubRef.current = angelOneWebSocketService.onPrice((tick) => {
      handleLivePriceUpdate(tick);
    });
    angelWsErrorUnsubRef.current = angelOneWebSocketService.onError((error) => {
      console.error("❌ AngelOne WebSocket error:", error);
    });

    angelOneWebSocketService.connect();

    return () => {
      angelWsStatusUnsubRef.current?.();
      angelWsPriceUnsubRef.current?.();
      angelWsErrorUnsubRef.current?.();
      angelWsStatusUnsubRef.current = null;
      angelWsPriceUnsubRef.current = null;
      angelWsErrorUnsubRef.current = null;
    };
  }, [isAngelOneBroker]);

  useEffect(() => {
    if (isGrowBroker || isAngelOneBroker) {
      return undefined;
    }

    const unsubscribeDepthStore = fivePaisaMarketDepthStore.subscribe((snap) => {
      setMarketDepth(Array.isArray(snap?.activeDepthData) ? snap.activeDepthData : []);
    });

    return () => {
      unsubscribeDepthStore?.();
      fivePaisaMarketDepthStore.closeDepth();
    };
  }, [isGrowBroker, isAngelOneBroker]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        marketDepthPopoverRef.current &&
        !marketDepthPopoverRef.current.contains(event.target) &&
        marketDepthButtonRef.current &&
        !marketDepthButtonRef.current.contains(event.target)
      ) {
        handleModalClose();
      }
    };

    if (showMarketDepth) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMarketDepth]);


  useEffect(() => {
    console.log(" ////////// activeTab3:", activeTab3);
    // Your UI rendering is based on marketDepthCache here
  }, [activeTab3]);



  useEffect(() => {
    console.log(" ////////// activeTab:", activeTab);
    // Your UI rendering is based on marketDepthCache here
  }, [activeTab]);



  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       clearSearch();
  //     }
  //   }

  //   if (isActive) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [isActive]);

  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (
  //       dropdownRef.current &&
  //       !dropdownRef.current.contains(event.target) &&
  //       excludedButtonRef1.current &&
  //       !excludedButtonRef1.current.contains(event.target) &&
  //       excludedButtonRef2.current &&
  //       !excludedButtonRef2.current.contains(event.target)
  //     ) {
  //       clearSearch();
  //     }
  //   }

  //   if (isActive) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [isActive]);


  useEffect(() => {
    function handleClickOutside(event) {
      setTimeout(() => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target) &&
          (!excludedButtonRef1.current ||
            !excludedButtonRef1.current.contains(event.target)) &&
          (!excludedButtonRef2.current ||
            !excludedButtonRef2.current.contains(event.target))
        ) {
          clearSearch();
        }
      }, 0);
    }
  
    document.addEventListener("pointerdown", handleClickOutside);
  
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    const handleOpenSearch = () => {
      setIsActive(true);
  
      // focus input
      setTimeout(() => {
        const input = dropdownRef.current?.querySelector("input");
        if (input) {
          input.focus();
  
          // optional: add space trick
          if (!query) {
            setQuery(" ");
            // setTimeout(() => setQuery(""), 100);
          }
        }
      }, 50);
    };
  
    window.addEventListener("openStockSearch", handleOpenSearch);
  
    return () => {
      window.removeEventListener("openStockSearch", handleOpenSearch);
    };
  }, [query]);


  const OrderType = [
    { value: "Market Order", label: tr("marketOrder") },
    { value: "Limit Order", label: tr("limitOrder") },
  ];

  const [orderType, setOrderType] = useState("Market Order");
  const [qty, setQty] = useState(1);
  const [isPreview, setIsPreview] = useState(false);










  //----------------------------// Functions //----------------------------//



  // Notification sound function
  const pingNotification = () => {
    try {
      const audio = new Audio('/sounds/notifications.mp3');
      audio.play().catch(error => {
        console.error('Failed to play notification sound:', error);
      });
    } catch (error) {
      console.error('Error creating audio:', error);
    }
  };

  // Common toast options
  const toastOptions = {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  };

  // Success toast function
  const showSuccessToast = (message) => {
    toast.success(message, {
      ...toastOptions,
      icon: "✅",
    });
    pingNotification()
  };

  // Error toast function
  const showErrorToast = (message) => {
    toast.error(message, {
      ...toastOptions,
      icon: "⚠️",
    });
    pingNotification()
  };


  // Error toast function
  const showWarningToast = (message) => {
    toast.warn(message, {
      ...toastOptions,
      icon: "⚠️",
    });
    pingNotification()
  };

  const handleSwitchBroker = async (brokerFlag) => {
    const normalizedFlag = String(brokerFlag || "").trim().toLowerCase();
    if (!normalizedFlag || normalizedFlag === brokerTypeRaw) return;

    const email =
      localStorage.getItem("email") ||
      sharedData?.Email_ID ||
      sharedData?.user?.email ||
      "";

    if (!email) {
      showErrorToast("Email not found. Please login again.");
      return;
    }

    setShowBrokerDropdown(false);
    setIsLoading(true);

    try {
      const response = await fetch(`${pmsApiBaseUrl}/api/v1/switch-broker`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          broker_flag: normalizedFlag,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const payload = data?.data || {};
      const status = String(payload?.status || "").toLowerCase();
      const message = payload?.message || "Failed to switch broker";

      if (status === "success") {
        persistAuthSessionFromPayload(payload);

        const store = useBrokerStatisticsStore.getState();
        store.reset();
        store.initializeFromUserBrokers();

        try {
          await hydrateAllBrokerStatistics({
            pmsApiBaseUrl,
            email,
            activeBrokerFlag: normalizedFlag,
          });
          store.cacheStatsForPageReload();
        } catch (hydrateError) {
          console.warn(
            "[switch-broker] inactive statistics hydrate failed:",
            hydrateError,
          );
        }

        window.location.reload();
        return;
      }

      showErrorToast(message);
      setIsLoading(false);
    } catch (error) {
      console.error("Switch broker error:", error);
      showErrorToast("Failed to switch broker. Please try again.");
      setIsLoading(false);
    }
  };


  // Debounced search function
  //   const debouncedSearch = useCallback(
  //   (searchValue) => {
  //     if (debounceTimeout.current) {
  //       clearTimeout(debounceTimeout.current);
  //     }

  //     debounceTimeout.current = setTimeout(async () => {
  //       if (searchValue.length >= 3) {
  //         try {
  //           const response = await fetch(
  //             "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=get5PaisaAllsearch",
  //             {
  //               method: "POST",
  //               headers: {
  //                 "Content-Type": "application/json",
  //               },
  //               body: JSON.stringify({
  //                 Name: searchValue,
  //               }),
  //             }
  //           );

  //           const data = await response.json();

  //           if (data.message !== "data does not match" && data.status !== "error") {
  //             console.log("🔍 Search results:", data);
  //             const results = data.data || [];
  //             setSearchResults(results.reverse());

  //             // 🔥 Connect WebSocket if not already connected
  //             if (!connected) {
  //               handleConnectClick();
  //             }

  //             // 🔥 REPLACE THIS PART - Use batch subscription instead of loop
  //             setTimeout(() => {
  //               if (results.length > 0) {
  //                 console.log(`🚀 Batch subscribing to ${results.length} search results...`);
  //                 sendBatchMessageToWebSocket(results, sharedData.ClientCode, "Search");
  //               }
  //             }, 1000); // Wait 1 second for WebSocket connection

  //           } else {
  //             setSearchResults([]);
  //           }
  //         } catch (error) {
  //           console.error("Error fetching suggestions:", error);
  //           setSearchResults([]);
  //         }
  //       } else {
  //         setSearchResults([]);
  //       }

  //       debounceTimeout.current = null;
  //     }, 500);
  //   },
  //   [connected, sharedData]
  // );

  const getExchangeFromTab = (tab) => {
    const map = {
      NSE: "nse",
      BSE: "bse",
      MCX: "mcx",
      stocks: "",
    };

    return map[String(tab)] ?? "";
  };

  const debouncedSearch = useCallback(
    (searchValue) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(async () => {
        if (searchValue.length < 3) {
          stopSearchLiveUpdates();
          setSubscribedStocks([]);
          resetSearchLiveCaches();
          setSearchResults([]);
          debounceTimeout.current = null;
          return;
        }

        const brokerFlag = String(localStorage.getItem("broker_type") || "").toLowerCase();
        const adapter = getSearchAdapter(brokerFlag);
        console.log(" ////// FINAL EXCHANGE:", getExchangeFromTab(activeTab));
        console.log(" ////// FINAL activeTab:", activeTab);

        try {
          const response = await fetch(
            `${pmsApiBaseUrl}/api/v1/search_stocks`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                user_id:
                  Number(localStorage.getItem("id")) ||
                  Number(sharedData?.ID) ||
                  0,
                search: searchValue,
                flag: brokerFlag,
                limit: (brokerFlag === "5paisa" && activeTab === "MCX") ? 100 : SEARCH_LIMIT,
                exchange: getExchangeFromTab(activeTab),

              }),
            },
          );
          const data = await response.json();
          const apiData = data?.data || {};
          const rows = Array.isArray(apiData?.rows) ? apiData.rows : [];
          const status = String(apiData?.status || "").toLowerCase();

          if (status !== "success" || rows.length === 0) {
            stopSearchLiveUpdates();
            setSubscribedStocks([]);
            resetSearchLiveCaches();
            setSearchResults([]);
            debounceTimeout.current = null;
            return;
          }

          const normalized = adapter.normalizeRows(rows);
          stopSearchLiveUpdates();
          resetSearchLiveCaches();
          setSearchResults(normalized);

          if (brokerFlag === "5paisa") {
            setSubscribedStocks(normalized);
            const wsFeedItems = normalized
              .map((item) => ({
                Exch: item.Exch,
                ExchType: item.ExchType || "C",
                ScripCode: Number(item.Scripcode),
              }))
              .filter((item) => item.Exch && item.ExchType && item.ScripCode);

            const batches = toBatches(wsFeedItems, SEARCH_BATCH_SIZE);
            fivePaisaWebSocketService.connect();
            batches.forEach((batch) => {
              fivePaisaWebSocketService.subscribeMarketFeed(batch);
              searchFeedSubscriptionRef.current = [
                ...searchFeedSubscriptionRef.current,
                ...batch,
              ];
            });
          } else if (brokerFlag === "grow") {
            setSubscribedStocks([]);
            const pollingKeys = normalized.map((item) => getGrowwPollingKey(item)).filter(Boolean);

            growwLivePriceService.setSymbols(GROW_POLL_SOURCE, pollingKeys);
            growwSearchUnsubscribeRef.current = growwLivePriceService.subscribe((payload) => {
              let hasUpdates = false;
              normalized.forEach((item) => {
                const key = getGrowwPollingKey(item);
                if (!key) return;

                const ltp = Number(payload?.[key]);
                if (!Number.isFinite(ltp)) return;

                const cacheKey = String(item.Scripcode);
                livePriceCache.current[cacheKey] = ltp;
                hasUpdates = true;
              });

              if (hasUpdates) {
                setLiveUpdateTrigger((prev) => prev + 1);
              }
            });
            growwLivePriceService.startPolling(1000);
          } else if (brokerFlag === "angelone") {
            setSubscribedStocks(normalized);
            const wsFeedItems = normalized
              .map((item) => ({
                exchangeType: getAngelExchangeTypeFromHolding({
                  Exch: item.Exch,
                  ExchSeg: item.ExchSeg,
                  ExchType: item.ExchType,
                  InstrumentType: item.InstrumentType,
                }),
                token: String(item.Token || item.Scripcode || "").trim(),
              }))
              .filter((item) => item.exchangeType && item.token);

            const batches = toBatches(wsFeedItems, SEARCH_BATCH_SIZE);
            angelOneWebSocketService.connect();
            batches.forEach((batch) => {
              angelOneWebSocketService.subscribeMarketFeed(batch);
              searchFeedSubscriptionRef.current = [
                ...searchFeedSubscriptionRef.current,
                ...batch,
              ];
            });
          } else {
            setSubscribedStocks([]);
          }
        } catch (error) {
          console.error("Error fetching suggestions:", error);
          stopSearchLiveUpdates();
          setSubscribedStocks([]);
          resetSearchLiveCaches();
          setSearchResults([]);
        }

        debounceTimeout.current = null;
      }, 500);
    },
    [pmsApiBaseUrl, activeTab],
  );

  useEffect(() => {
    if (!query || query.length < 3) return;

    debouncedSearch(query);
  }, [activeTab]);


  const handleCreateWatchlistHeaderAndAddToWatchlist = async () => {
    setWatchlistError('');

    const trimmedName = newWatchlistName.trim();

    // Validation
    if (!trimmedName) {
      setWatchlistError(tr("watchlistNameCannotBeEmpty"));
      return;
    }

    if (trimmedName.length > 30) {
      setWatchlistError(tr("watchlistNameUnder30"));
      return;
    }

    // Check for duplicates
    const isDuplicate = headerUserWatchlists.some(
      name => name.toLowerCase() === trimmedName.toLowerCase()
    );

    if (isDuplicate) {
      setWatchlistError(tr("watchlistNameAlreadyExists"));
      return;
    }

    // Check limit
    if (headerUserWatchlists.length >= 5) {
      setWatchlistError(tr("maximum5WatchlistsAllowed"));
      return;
    }

    // API call
    try {
      const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      const brokerFlag = String(localStorage.getItem("broker_type") || "").toLowerCase();
      if (!userId || !brokerFlag) {
        setWatchlistError(tr("failedToCreateWatchlist"));
        return;
      }

      const response = await fetch(
        `${pmsApiBaseUrl}/api/v1/watchlist/create`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userId,
            broker_flag: brokerFlag,
            watchlist_name: trimmedName,
          })
        }
      );

      const data = await response.json();
      const apiData = data?.data || {};
      const status = String(apiData?.status || "").toLowerCase();
      const message = apiData?.message || tr("failedToCreateWatchlist");

      if (status === 'success') {
        // Show success message
        showSuccessToast(message);

        // Clear form
        setNewWatchlistName('');
        setWatchlistError('');

        // ✅ Close Create New Watchlist modal using hidden button
        const hiddenCloseCreateBtn = document.getElementById('hiddenCloseCreateWatchlistModalBtn');
        if (hiddenCloseCreateBtn) {
          hiddenCloseCreateBtn.click();
        }

        // ✅ Close Select Watchlist modal using hidden button
        const hiddenCloseSelectBtn = document.getElementById('hiddenCloseSelectWatchlistModalBtn');
        if (hiddenCloseSelectBtn) {
          hiddenCloseSelectBtn.click();
        }

        // Add selected stock to newly created watchlist (resolve latest watchlist ID first)
        const latestWatchlists = await fetchUserWatchlistsForHeader();
        const newlyCreatedWatchlist = (latestWatchlists || []).find(
          (item) => item?.name === trimmedName,
        );
        if (newlyCreatedWatchlist) {
          await handleAddToSpecificWatchlist(newlyCreatedWatchlist);
        } else {
          setSelectedStockToAdd(null);
        }

        // ✅ Trigger watchlist refresh if on Watchlist tab
        if (tabName === "Watchlist" && setUpdateWatchlistTrigger) {
          setUpdateWatchlistTrigger(Math.random() * 100 + 1);
        }

        // Refresh watchlist data for header

        fetchUserWatchlistsForHeader();

      } else {
        setWatchlistError(message);
      }

    } catch (error) {
      console.error('Error creating watchlist:', error);
      setWatchlistError(tr("failedToCreateWatchlist"));
    }
  };



  const handleCancelCreateWatchlist = () => {
    // Clear form state
    setNewWatchlistName('');
    setWatchlistError('');

    // Close Create New Watchlist modal (Modal 2) using hidden button
    const hiddenCloseCreateBtn = document.getElementById('hiddenCloseCreateWatchlistModalBtn');
    if (hiddenCloseCreateBtn) {
      hiddenCloseCreateBtn.click();
    }

    // Close Select Watchlist modal (Modal 1 - parent modal) using hidden button
    const hiddenCloseSelectBtn = document.getElementById('hiddenCloseSelectWatchlistModalBtn');
    if (hiddenCloseSelectBtn) {
      hiddenCloseSelectBtn.click();
    }

    // Clear selected stock
    setSelectedStockToAdd(null);
  };











  const formatNumber = (num) => {
    if (num === null || num === undefined) return "-";
    const number = parseFloat(num);
    if (isNaN(number)) return "-";

    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatSignedCurrency = (num) => {
    if (num === null || num === undefined || num === "") return "—";
    const value = Number(num);
    if (!Number.isFinite(value)) return "—";
    const prefix = value < 0 ? "-₹" : "₹";
    return `${prefix}${formatNumber(Math.abs(value))}`;
  };

  const getPlTone = (value) => {
    const num = Number(value) || 0;
    if (num > 0) return "up";
    if (num < 0) return "down";
    return "flat";
  };

  const renderBrokerInlineStat = (label, value, tone = "flat") => (
    <span className="broker-card__inline-stat">
      <span className="broker-card__inline-label">{label}</span>
      <span className={`broker-card__inline-value broker-card__inline-value--${tone}`}>
        {value}
      </span>
    </span>
  );

  const renderBrokerDropdownOption = (brokerFlag, display, isActive) => {
    const stats = statsByBroker[brokerFlag];
    const isStatsLoading = !stats?.isLoaded;

    const overallPL = Number(stats?.overall_profit_loss) || 0;
    const todayPL = Number(stats?.today_profit_loss) || 0;
    const todayPLPct = Number(stats?.today_profit_loss_percentage) || 0;

    return (
      <>
        <div className="broker-card__top">
          {/* <div className="broker-card__brand">
            {display.logo ? (
              <img
                src={display.logo}
                alt={`${display.name} logo`}
                className={
                  display.isAngel
                    ? "broker-card__logo broker-card__logo--angel"
                    : "broker-card__logo"
                }
              />
            ) : (
              <span className="broker-card__name">{display.name}</span>
            )}
            {isActive ? <span className="broker-card__badge">Active</span> : null}
          </div> */}
          <div className="broker-card__brand">
            <span className="broker-card__name broker-card__name--premium">
              <span className="broker-card__avatar">
                <UserRound size={12} strokeWidth={2.4} />
              </span>
              <span className="broker-card__name-text">
                {brokerFlag === "current"
                  ? (localStorage.getItem("account_name") || display.name)
                  : (userBrokers.find(
                      (item) =>
                        String(item?.broker_flag || "").toLowerCase() === brokerFlag
                    )?.account_name || display.name)}
              </span>
            </span>

            {isActive ? <span className="broker-card__badge">Active</span> : null}
          </div>
          {isStatsLoading ? (
            <span className="broker-card__loading">…</span>
          ) : (
            <div className="broker-card__margin">
              <span className="broker-card__margin-label">Margin</span>
              <span className="broker-card__margin-value">
                ₹{formatNumber(stats.margin)}
              </span>
            </div>
          )}
        </div>

        {!isStatsLoading ? (
          <div className="broker-card__stats">
            <div className="broker-card__stat-row">
              {renderBrokerInlineStat(
                "Invested",
                `₹${formatNumber(stats.total_investment_amount)}`,
              )}
              {renderBrokerInlineStat(
                "Portfolio",
                `₹${formatNumber(stats.current_value)}`,
              )}
            </div>
            <div className="broker-card__stat-row">
              {renderBrokerInlineStat(
                "P&L",
                formatSignedCurrency(overallPL),
                getPlTone(overallPL),
              )}
              <span className="broker-card__inline-stat">
                <span className="broker-card__inline-label">Today</span>
                <span
                  className={`broker-card__inline-value broker-card__inline-value--${getPlTone(todayPL)}`}
                >
                  {formatSignedCurrency(todayPL)}
                  <span className="broker-card__inline-pct">
                    ({todayPLPct >= 0 ? "+" : ""}
                    {formatNumber(todayPLPct)}%)
                  </span>
                </span>
              </span>
            </div>
          </div>
        ) : null}
      </>
    );
  };




  //   const handleConnectClick = () => {
  //   const saved = JSON.parse(localStorage.getItem("sharedData"));
  //   if (!saved?.accessToken || !saved?.ClientCode) {
  //     console.warn("❌ Cannot connect WebSocket — missing token or client code.");
  //     return;
  //   }

  //   const webSocket = new WebSocket(
  //     `wss://openfeed.5paisa.com/Feeds/api/chat?Value1=${saved.accessToken}|${saved.ClientCode}`
  //   );

  //   console.log("webSocket URL : " + webSocket.url);

  //   webSocket.onopen = () => {
  //     console.log("✅ 5paisa WebSocket connected");
  //     setConnected(true);
  //     setWs(webSocket);
  //     wsRef.current = webSocket;

  //     setupWebSocketMessageHandler(webSocket);
  //     startHeartbeat();
  //   };

  //   webSocket.onerror = (error) => {
  //     console.error("❌ WebSocket error:", error);
  //     setConnected(false);
  //   };

  //   webSocket.onclose = (event) => {
  //     console.log("WebSocket closed. Code:", event.code, "Reason:", event.reason, "Clean:", event.wasClean);
  //     setConnected(false);

  //     if (heartbeatIntervalRef.current) {
  //       clearInterval(heartbeatIntervalRef.current);
  //       heartbeatIntervalRef.current = null;
  //     }
  //   };
  // };

  const handleConnectClick = () => {
    if (isAngelOneBroker) {
      return angelOneWebSocketService.connect();
    }
    return fivePaisaWebSocketService.connect();
  };





  // const sendBatchMessageToWebSocket = async (stocks, clientCode, status) => {
  //   const currentWs = wsRef.current;

  //   if (!currentWs || currentWs.readyState !== WebSocket.OPEN) {
  //     console.warn("WebSocket is not connected, readyState:", currentWs?.readyState);
  //     return;
  //   }

  //   // Determine batch size based on total stocks length
  //   const totalStocks = stocks.length;
  //   let batchSize = 100; // Default batch size

  //   if (totalStocks <= 100) {
  //     batchSize = totalStocks; // Send all in one message
  //   } else if (totalStocks <= 200) {
  //     batchSize = Math.ceil(totalStocks / 2); // Divide into 2 parts
  //   } else if (totalStocks <= 300) {
  //     batchSize = Math.ceil(totalStocks / 3); // Divide into 3 parts
  //   } else if (totalStocks <= 400) {
  //     batchSize = Math.ceil(totalStocks / 4); // Divide into 4 parts
  //   } else if (totalStocks <= 500) {
  //     batchSize = Math.ceil(totalStocks / 5); // Divide into 5 parts
  //   }

  //   console.log(`📊 Total stocks: ${totalStocks}, Batch size: ${batchSize}`);

  //   // Process stocks in batches
  //   for (let i = 0; i < stocks.length; i += batchSize) {
  //     const batch = stocks.slice(i, i + batchSize);

  //     // Prepare MarketFeedData array for this batch
  //     const marketFeedData = batch.map(stock => {
  //       let ScripCode = 0;
  //       let Exch = 0;
  //       let ExchType = 0;

  //       if (status === "Search") {
  //         ScripCode = stock.Scripcode;
  //         Exch = stock.Exch;
  //         ExchType = stock.ExchType;
  //       } else if (status === "Watchlist") {
  //         ScripCode = stock.scripcode;
  //         Exch = stock.exch?.charAt(0);
  //         ExchType = stock.exchType?.charAt(0);
  //       } else {
  //         ScripCode = stock.Exch === "N" ? stock.NseCode : stock.BseCode;
  //         Exch = stock.Exch?.charAt(0);
  //         ExchType = stock.ExchType?.charAt(0);
  //       }

  //       // Add to subscribed codes
  //       if (!subscribedScripCodes.current) {
  //         subscribedScripCodes.current = new Set();
  //       }
  //       subscribedScripCodes.current.add(ScripCode);

  //       return {
  //         Exch,
  //         ExchType,
  //         ScripCode,
  //       };
  //     });

  //     // Create batch message
  //     const batchMessage = {
  //       Method: "MarketFeedV3",
  //       Operation: "Subscribe",
  //       ClientCode: clientCode,
  //       MarketFeedData: marketFeedData,
  //     };

  //     try {
  //       currentWs.send(JSON.stringify(batchMessage));
  //       console.log(`✅ Batch ${Math.floor(i/batchSize) + 1}: Subscribed to ${batch.length} stocks`);

  //       // Log the stock names for debugging
  //       const stockNames = batch.map(stock => stock.Name || stock.Symbol).join(', ');
  //       console.log(`📈 Subscribed stocks: ${stockNames}`);

  //     } catch (error) {
  //       console.error("Error sending batch WebSocket message:", error);
  //     }

  //     // Small delay between batches to avoid overwhelming the server
  //     if (i + batchSize < stocks.length) {
  //       await new Promise(resolve => setTimeout(resolve, 100)); // 100ms delay
  //     }
  //   }
  // };

  // Keep the original function for single stock subscriptions

  const sendBatchMessageToWebSocket = async (stocks, clientCode, status) => {
    if (isGrowBroker) return;

    if (isAngelOneBroker) {
      const angelFeedItems = (stocks || [])
        .map((stock) => {
          if (status === "Search") {
            return {
              exchangeType: getAngelExchangeTypeFromHolding({
                Exch: stock.Exch,
                ExchSeg: stock.ExchSeg,
                ExchType: stock.ExchType,
                InstrumentType: stock.InstrumentType,
              }),
              token: String(stock.Token || stock.Scripcode || "").trim(),
            };
          }
          return {
            exchangeType: getAngelExchangeTypeFromHolding(stock),
            token: String(
              stock?.token || stock?.Token || stock?.script_code || stock?.scripcode || "",
            ).trim(),
          };
        })
        .filter((item) => item.exchangeType && item.token);

      if (!angelFeedItems.length) return;
      angelOneWebSocketService.connect();
      toBatches(angelFeedItems, SEARCH_BATCH_SIZE).forEach((batch) => {
        angelOneWebSocketService.subscribeMarketFeed(batch);
      });
      return;
    }

    const marketFeedData = (stocks || [])
      .map((stock) => {
        if (status === "Search") {
          return {
            Exch: stock.Exch,
            ExchType: stock.ExchType,
            ScripCode: Number(stock.Scripcode),
          };
        }
        if (status === "Watchlist") {
          return {
            Exch: stock.exch?.charAt(0),
            ExchType: stock.exchType?.charAt(0),
            ScripCode: Number(stock.scripcode),
          };
        }
        return {
          Exch: stock.Exch?.charAt(0),
          ExchType: stock.ExchType?.charAt(0),
          ScripCode: Number(stock.Exch === "N" ? stock.NseCode : stock.BseCode),
        };
      })
      .filter((item) => item.Exch && item.ExchType && item.ScripCode);

    if (!marketFeedData.length) return;
    fivePaisaWebSocketService.connect();
    fivePaisaWebSocketService.subscribeMarketFeed(marketFeedData);
  };





  const sendMessageToWebSocket = (holding, clientCode, status) => {
    const currentWs = wsRef.current;

    if (!currentWs || currentWs.readyState !== WebSocket.OPEN) {
      console.warn("✅WebSocket is not connected, readyState:", currentWs?.readyState);
      return;
    }

    let ScripCode = 0;
    let Exch = 0;
    let ExchType = 0;

    if (status === "Search") {
      ScripCode = holding.Scripcode;
      Exch = holding.Exch;
      ExchType = holding.ExchType;
    } else if (status === "Watchlist") {
      ScripCode = holding.scripcode;
      Exch = holding.exch?.charAt(0);
      ExchType = holding.exchType?.charAt(0);
    } else {
      ScripCode = holding.Exch === "N" ? holding.NseCode : holding.BseCode;
      Exch = holding.Exch?.charAt(0);
      ExchType = holding.ExchType?.charAt(0);
    }

    const priceMessage = {
      Method: "MarketFeedV3",
      Operation: "Subscribe",
      ClientCode: clientCode,
      MarketFeedData: [
        {
          Exch,
          ExchType,
          ScripCode,
        },
      ],
    };

    try {
      currentWs.send(JSON.stringify(priceMessage));
      console.log(`✅ Subscribed to ${holding.Name || holding.Symbol} (${ScripCode})`);
      // console.log(`✅ Subscribed to ${JSON.stringify(priceMessage)} `);

      if (!subscribedScripCodes.current) {
        subscribedScripCodes.current = new Set();
      }
      subscribedScripCodes.current.add(ScripCode);
    } catch (error) {
      console.error("Error sending WebSocket message:", error);
    }
  };


  const setupWebSocketMessageHandler = (websocket) => {
    const ws = websocket || wsRef.current;

    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.onmessage = (event) => {
        try {
          const receivedData = JSON.parse(event.data);

          if (receivedData.Method === "Heartbeat") {
            console.log("💗 Heartbeat response received");
            return;
          }

          // For Market Depth (global store handles this now)
          if (receivedData.Details && Array.isArray(receivedData.Details) && receivedData.Token) {
            return;
          }

          if (Array.isArray(receivedData) && receivedData[0]) {
            const data = receivedData[0];
            handleLivePriceUpdate(data);
          }

        } catch (error) {
          console.error("❌ Error processing WebSocket message:", error);
        }
      };
    }
  };

  const handleLivePriceUpdate = (data) => {
    const { Token: scriptCode, LastRate: lastRateValue, PClose, Volume } = data;

    if (!scriptCode || lastRateValue === undefined) return;

    if (!livePriceCache.current) livePriceCache.current = {};
    if (!livePCloseCache.current) livePCloseCache.current = {};
    if (!liveDiffCache.current) liveDiffCache.current = {};
    if (!liveChangePercentageCache.current) liveChangePercentageCache.current = {};
    if (!liveVolumeCache.current) liveVolumeCache.current = {};
    if (!livePLCache.current) livePLCache.current = {};

    livePriceCache.current[scriptCode] = lastRateValue;
    livePCloseCache.current[scriptCode] = PClose;
    liveDiffCache.current[scriptCode] = lastRateValue - PClose;
    liveChangePercentageCache.current[scriptCode] = ((lastRateValue - PClose) / PClose) * 100;
    liveVolumeCache.current[scriptCode] = Volume;

    const totalPL = lastRateValue - PClose;
    livePLCache.current[scriptCode] = `${totalPL.toFixed(2)} (${liveChangePercentageCache.current[scriptCode].toFixed(2)}%)`;

    setLiveUpdateTrigger((prev) => prev + 1);
    // console.log(`Price Update: ${scriptCode} = ₹${lastRateValue}`);
  };



  const startHeartbeat = () => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
    }

    heartbeatIntervalRef.current = setInterval(() => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        try {
          wsRef.current.send(JSON.stringify({
            Method: "Heartbeat",
            Operation: "Ping",
            Timestamp: new Date().getTime()
          }));
          console.log("💗 Heartbeat sent");
        } catch (error) {
          console.error("❌ Error sending heartbeat:", error);
        }
      }
    }, 30000);
  };




  const handlePreview = () => setIsPreview(true);
  const handleGoBack = () => setIsPreview(false);




  const SettingBuyModalDetails = (stockData, Type) => {
    setBuySellModalDetails(prevState => ({
      ...prevState,
      FullName: stockData.FullName || stockData.fullName || '',
      Symbol: stockData.Symbol || stockData.Name || stockData.name || '',
      Type: Type,
      OrderQty: 1,
      LimitPrice: 0,
      order: stockData // store complete order object
    }));
  };





  // 🔥 Connection monitor - checks every 5 seconds and reconnects if needed
  // const startConnectionMonitor = () => {
  //   if (connectionMonitorRef.current) {
  //     clearInterval(connectionMonitorRef.current);
  //   }

  //   connectionMonitorRef.current = setInterval(() => {
  //     const currentWs = wsRef.current;

  //     if (!currentWs || currentWs.readyState === WebSocket.CLOSED || currentWs.readyState === WebSocket.CLOSING) {
  //       console.log("🔄 WebSocket disconnected, attempting to reconnect...");
  //       handleConnectClick();

  //       // Resubscribe to holdings after reconnection
  //       setTimeout(() => {
  //         if (lastSubscribedHoldings.current.length > 0) {
  //           console.log("🔄 Resubscribing to holdings after reconnection...");
  //           const saved = JSON.parse(localStorage.getItem("sharedData"));
  //           lastSubscribedHoldings.current.forEach((holding) => {
  //             sendMessageToWebSocket(holding, saved.ClientCode, "Portfolio");
  //           });
  //         }
  //       }, 1000); // Wait 1 second for WebSocket to reconnect
  //     }
  //   }, 2000); // Check every 5 seconds
  // };

  const startConnectionMonitor = () => {
    if (connectionMonitorRef.current) {
      clearInterval(connectionMonitorRef.current);
    }

    connectionMonitorRef.current = setInterval(async () => {
      const currentWs = wsRef.current;

      if (!currentWs || currentWs.readyState === WebSocket.CLOSED || currentWs.readyState === WebSocket.CLOSING) {
        console.log("🔄 WebSocket disconnected, attempting to reconnect...");

        try {
          await handleConnectClick(); // Wait for WS to fully connect

          const saved = JSON.parse(localStorage.getItem("sharedData"));

          // Resubscribe to holdings
          if (lastSubscribedHoldings.current.length > 0) {
            console.log("🔄 Resubscribing to holdings after reconnection...");
            handleConnectClick()
            lastSubscribedHoldings.current.forEach((holding) => {
              sendMessageToWebSocket(holding, saved.ClientCode, "Portfolio");
            });
          }

          // Resubscribe to search results
          if (subscribedStocks.length > 0) {
            console.log("🔄 Resubscribing to search results after reconnection...");
            handleConnectClick()
            subscribedStocks.forEach((stock) => {
              sendMessageToWebSocket(stock, saved.ClientCode, "Search");
            });
          }

        } catch (error) {
          console.error("❌ Error reconnecting WebSocket:", error);
        }
      }
    }, 2000); // Check every 2 seconds
  };



  // 🔥 Cleanup function
  const cleanupWebSocket = () => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
      heartbeatIntervalRef.current = null;
    }

    if (connectionMonitorRef.current) {
      clearInterval(connectionMonitorRef.current);
      connectionMonitorRef.current = null;
    }

    if (wsRef.current) {
      wsRef.current.close();
      wsRef.current = null;
    }

    setConnected(false);
    setWs(null);
  };






  const clearSearch = () => {
    stopSearchLiveUpdates();
    setSubscribedStocks([]);
    resetSearchLiveCaches();
    setQuery("");
    setIsActive(false);
    setSearchResults([]);
  };


  //----------------------------//  Select Watchlist Functions //----------------------------//`

  const fetchUserWatchlistsForHeader = async () => {
    setIsLoadingWatchlists(true);

    try {
      const userIdFromStorage = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      const brokerFlag = String(localStorage.getItem("broker_type") || "").toLowerCase();

      if (!userIdFromStorage || !brokerFlag) {
        setHeaderUserWatchlists([]);
        return [];
      }

      const response = await fetch(
        `${pmsApiBaseUrl}/api/v1/watchlist/list`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userIdFromStorage,
            broker_flag: brokerFlag,
          })
        }
      );

      const data = await response.json();
      const apiData = data?.data || {};
      const watchlists = Array.isArray(apiData?.watchlists) ? apiData.watchlists : [];

      if (String(apiData?.status || "").toLowerCase() === "success") {
        const mappedWatchlists = watchlists
          .map((item) => ({
            id: String(item?.id || "").trim(),
            name: String(item?.watchlist_name || "").trim(),
          }))
          .filter((item) => item.id && item.name);

        const watchlistNames = mappedWatchlists
          .map((item) => item.name)
          .filter(Boolean);
        setHeaderWatchlistEntries(mappedWatchlists);
        setHeaderUserWatchlists(watchlistNames);
        return mappedWatchlists;
      } else {
        setHeaderWatchlistEntries([]);
        setHeaderUserWatchlists([]);
        return [];
      }

    } catch (error) {
      console.error('Error fetching watchlists:', error);
      setHeaderWatchlistEntries([]);
      setHeaderUserWatchlists([]);
      return [];
    } finally {
      setIsLoadingWatchlists(false);
    }
  };




  //----------------------------//  Add to Watchlist Functions //----------------------------//`


  // const addWatchlist = (stock) => {
  //   if (!stock || !stock.Name || stock.Name.trim() === "") {
  //     return false;
  //   }

  //   // Map stock fields to required payload fields
  //   const exch = stock.Exch || "";
  //   const exchType = stock.ExchType === "D" ? "Derivative" : "Cash";
  //   const name = stock.Name;
  //   const scripcode = stock.Scripcode ? String(stock.Scripcode) : "";

  //   const requestData = {
  //     exch,
  //     exchType,
  //     name,
  //     scripcode,
  //     userId: sharedData.ID,
  //     watchlistName: activeTab3, // ✅ Added activeTab as watchlistName 
  //     columns: [],
  //   };

  //   fetch(
  //     `https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=addWatchlist2`,
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(requestData),
  //     }
  //   )
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("✅✅✅Network response was not ok");
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       if (data.status === "error") {
  //         console.log("✅✅✅Error: ", data.message);
  //         showErrorToast(data.message);
  //         return false;
  //       } else if (data.status === "success") {
  //         console.log("✅✅✅ DONE:",data.message);
  //         showSuccessToast(data.message);
  //         if (tabName === "Watchlist"){
  //           setUpdateWatchlistTrigger(Math.random()*100 + 1)
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("✅✅✅There was a problem with the adding watchlist operation:", error);
  //     });


  // };

  const addWatchlist = (stock) => {
    if (!stock || !stock.Name || stock.Name.trim() === "") {
      showErrorToast(tr("invalidStockData"));
      return false;
    }

    // Store stock for modal
    setSelectedStockToAdd(stock);

    // Fetch watchlists
    fetchUserWatchlistsForHeader();

    // Modal will open automatically via data-bs-toggle
    return true;
  };


  const handleAddToSpecificWatchlist = async (watchlist) => {
    if (!selectedStockToAdd) {
      showErrorToast(tr("noStockSelected"));
      return;
    }

    const watchlistId = String(watchlist?.id || "").trim();
    const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
    const brokerFlag = String(localStorage.getItem("broker_type") || "").toLowerCase();
    const scriptCode = selectedStockToAdd.Scripcode ? String(selectedStockToAdd.Scripcode) : "";
    const stockName = String(
      selectedStockToAdd.InstrumentName || selectedStockToAdd.Name || "",
    ).trim();
    const tradingSymbol = String(
      selectedStockToAdd.TradingSymbol ||
      selectedStockToAdd.Symbol ||
      selectedStockToAdd.Name ||
      "",
    ).trim();
    const rawExchange = String(selectedStockToAdd?.Exch || "").toUpperCase();
    const exchangeFor5Paisa = rawExchange || "N";
    const exchangeForGrow = rawExchange === "B" ? "BSE" : rawExchange === "M" ? "MCX" : "NSE";
    const angelOneToken = String(selectedStockToAdd.Token || selectedStockToAdd.Scripcode || "").trim();
    const angelOneSymbol = String(
      selectedStockToAdd.Symbol ||
      selectedStockToAdd.TradingSymbol ||
      "",
    ).trim();
    const angelOneDisplayName = String(
      selectedStockToAdd.InstrumentName || selectedStockToAdd.Name || "",
    ).trim();
    const angelOneExchange = String(
      selectedStockToAdd.ExchSeg ||
      (rawExchange === "B" ? "BSE" : rawExchange === "M" ? "MCX" : "NSE"),
    ).trim();

    if (!watchlistId || !userId || !brokerFlag) {
      showErrorToast(tr("failedToAddToWatchlist"));
      return;
    }

    let requestData;
    if (brokerFlag === "grow") {
      if (!tradingSymbol) {
        showErrorToast(tr("failedToAddToWatchlist"));
        return;
      }
      requestData = {
        action: "add",
        watchlist_id: watchlistId,
        user_id: userId,
        broker_flag: brokerFlag,
        trading_symbol: tradingSymbol,
        exchange: exchangeForGrow,
      };
    } else if (brokerFlag === "angelone") {
      if (!angelOneToken || !angelOneSymbol || !angelOneDisplayName || !angelOneExchange) {
        showErrorToast(tr("failedToAddToWatchlist"));
        return;
      }
      requestData = {
        action: "add",
        broker_flag: brokerFlag,
        user_id: userId,
        watchlist_id: watchlistId,
        token: angelOneToken,
        symbol: angelOneSymbol,
        name: angelOneDisplayName,
        exch_seg: angelOneExchange,
      };
    } else {
      if (!scriptCode || !stockName) {
        showErrorToast(tr("failedToAddToWatchlist"));
        return;
      }
      requestData = {
        action: "add",
        watchlist_id: watchlistId,
        user_id: userId,
        broker_flag: brokerFlag,
        script_code: scriptCode,
        name: stockName,
        exchange: exchangeFor5Paisa,
      };
    }

    console.log("Adding to watchlist:", requestData);

    try {
      const response = await fetch(
        `${pmsApiBaseUrl}/api/v1/watchlist/symbol`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData)
        }
      );

      // if (!response.ok) {
      //   throw new Error("Network response was not ok");
      // }

      const data = await response.json();
      const apiData = data?.data || data || {};
      const status = String(apiData?.status || "").toLowerCase();
      const message = apiData?.message || tr("failedToAddToWatchlist");

      if (status === 'error') {
        console.log("Error:", message);
        showErrorToast(message);
      } else if (status === 'success') {
        console.log("Success:", message);
        showSuccessToast(message);

        // Close modal programmatically
        const closeButton = document.querySelector('#selectWatchlistModal [data-bs-dismiss="modal"]');
        if (closeButton) {
          closeButton.click();
        }

        // Clear selected stock
        setSelectedStockToAdd(null);

        // Trigger watchlist refresh if on Watchlist tab
        if (tabName === "Watchlist" && setUpdateWatchlistTrigger) {
          setUpdateWatchlistTrigger(Math.random() * 100 + 1);
        }
      }

    } catch (error) {
      console.error("Error adding to watchlist:", error);
      showErrorToast(tr("failedToAddToWatchlist"));
      // showErrorToast("Stock already added to watchlist");
    }
  };





  //----------------------------//  Buy-Sell Functions //----------------------------//`

  // Placing Order steps:
  // CDSL Record Count Function
  // CDSL Record Count Function with Debug Logging
  async function getCDSLRecordCount(userId) {
    console.log("🔍 getCDSLRecordCount - Starting function");
    console.log("📋 Input userId:", userId);

    const apiUrl = "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=getCDSLRecord";
    console.log("🌐 API URL:", apiUrl);

    try {
      console.log("📤 Preparing to send request...");

      const requestBody = { userId: userId };
      console.log("📦 Request body:", JSON.stringify(requestBody));

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      console.log("📥 Response received");
      console.log("✅ Response status:", response.status);
      console.log("📊 Response statusText:", response.statusText);
      console.log("🔗 Response OK:", response.ok);

      if (!response.ok) {
        console.error("❌ Response not OK - throwing error");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      console.log("🔄 Parsing response as JSON...");
      const data = await response.json();
      console.log("📋 Raw response data:", data);

      const count = data.count;
      console.log("🔢 Extracted count:", count);
      console.log("✅ getCDSLRecordCount - Function completed successfully");

      return count;
    } catch (error) {
      console.error("💥 Error in getCDSLRecordCount:");
      console.error("❌ Error message:", error.message);
      console.error("📊 Full error object:", error);
      console.log("🔄 Returning default value: 0");

      // Return 0 as default if error occurs
      return 0;
    }
  }



  const fetchDataPortfolio = (watchlist, transactionSide, status) => {
    console.log("🚀 fetchDataPortfolio - Starting function");
    console.log("📊 Input parameters:");
    console.log("   - watchlist:", watchlist);
    console.log("   - transactionSide:", transactionSide);
    console.log("   - status:", status);

    const Exch = watchlist.Exch;
    console.log("🏛️ Exchange (Exch):", Exch);

    const ExchType = Exch === "M" ? "D" : "C";
    console.log("📈 Exchange Type (ExchType):", ExchType, `(${Exch === "M" ? "Derivative" : "Cash"})`);

    const Name = watchlist.Name;
    console.log("🏢 Company Name:", Name);

    let Scripcode = "";

    if (status === "Portfolio") {
      // ✨ Use Number conversion for ScripCode with fallback
      Scripcode = Number(watchlist.ScripCode) || Number(watchlist.scripcode);
      console.log("📋 Portfolio mode - Using pre-calculated ScripCode:");
      console.log(`   - Exchange is ${watchlist.Exch}, ScripCode: ${Scripcode}`);
      console.log(`   - NseCode: ${watchlist.NseCode}, BseCode: ${watchlist.BseCode}`);
      console.log(`   - Selected Scripcode: ${Scripcode}`);
    } else {
      Scripcode = watchlist.Scripcode;
      console.log("📝 Watchlist mode - Using direct Scripcode:", Scripcode);
    }

    let watchlist_price = "0";
    let min_qty = "0";

    // ✅ Get values from modal state instead of DOM
    watchlist_price =
      orderType === "Market Order"
        ? "0"
        : buySellModalDetails.LimitPrice.toString();
    min_qty = buySellModalDetails.OrderQty.toString();

    console.log("💰 Price & Quantity from modal:");
    console.log("   - Execution (Market/Limit):", orderType);
    console.log("   - Price (watchlist_price):", watchlist_price);
    console.log("   - Quantity (min_qty):", min_qty);
    console.log("   - buySellModalDetails:", buySellModalDetails);

    const userId = sharedData.ID;
    console.log("👤 User ID:", userId);
    console.log("📱 sharedData object:", sharedData);

    const order_type = transactionSide;
    console.log("📊 Final order_type (Buy/Sell):", order_type);

    // Create a JavaScript object with the request data
    const requestData = {
      ExchType,
      order_type,
      Exch,
      Name,
      Scripcode,
      watchlist_price,
      min_qty,
      userId,
    };

    console.log("📦 Complete request data object:");
    console.log(JSON.stringify(requestData, null, 2));

    // ✅ CDSL validation for 5paisa Sell only (not Grow / AngelOne)
    if (transactionSide === "Sell" && isAngelOneBroker) {
      console.log("🛑 SELL order (AngelOne) - skipping CDSL validation");
      executeBuySellOrderPortfolio(
        requestData,
        watchlist,
        transactionSide,
        status,
      );
    } else if (transactionSide === "Sell") {
      console.log("🛑 SELL order detected - checking CDSL validation");
      getCDSLRecordCount(userId)
        .then((count) => {
          console.log("✅ CDSL validation completed");
          console.log("🔢 CDSL Record Count:", count);

          if (count === 0) {
            console.error("❌ CDSL Record Count is 0 - cannot place sell order");
            console.log("🚫 Sell order blocked - CDSL setup required");
            // TODO: Show error modal - user needs to complete CDSL setup
            // document.getElementById("modalClick").click();
          } else {
            console.log("✅ CDSL validation passed - proceeding with sell order");
            executeBuySellOrderPortfolio(requestData, watchlist, transactionSide, status);
          }
        })
        .catch((error) => {
          console.error("💥 Error getting CDSL count:", error);
          console.log("⚠️ CDSL validation failed - proceeding with order anyway");
          // Proceed with order anyway or show error
          executeBuySellOrderPortfolio(requestData, watchlist, transactionSide, status);
        });
    } else if (transactionSide === "Buy") {
      console.log("💚 BUY order detected - no CDSL validation needed");
      console.log("🚀 Proceeding directly to order execution");
      executeBuySellOrderPortfolio(requestData, watchlist, transactionSide, status);
    } else {
      console.error("❓ Unknown transaction side:", transactionSide);
    }

    console.log("🏁 fetchDataPortfolio - Function end");
  };




  // Function to handle the checkSell value
  const executeBuySellOrderPortfolio = (requestData, watchlist, transactionSide, status) => {
    console.log("🔧 executeBuySellOrderPortfolio - Starting function");
    console.log("📥 Input parameters:");
    console.log("   - requestData:", requestData);
    console.log("   - watchlist:", watchlist);
    console.log("   - transactionSide:", transactionSide);
    console.log("   - status:", status);

    // ✅ REMOVED: Database call - now happens AFTER order placement
    console.log("🚀 Proceeding to PMS place_order");
    clickPlaceOrderPortfolio(requestData, watchlist, transactionSide, status);

    console.log("🏁 executeBuySellOrderPortfolio - Function end");
  };



  const clickPlaceOrderPortfolio = (
    requestData,
    watchlist,
    transactionSide,
    status,
  ) => {
    const executionType = orderType;

    console.log("🎯 clickPlaceOrderPortfolio — PMS /api/v1/place_order");
    console.log(
      "   transactionSide:",
      transactionSide,
      "executionType:",
      executionType,
    );

    placeOrderViaPms({
      pmsApiBaseUrl,
      sharedData,
      watchlist,
      listStatus: status,
      transactionSide,
      executionType,
      qty: buySellModalDetails.OrderQty,
      limitPrice: buySellModalDetails.LimitPrice,
    }).then((result) => {
      if (result.error) {
        console.error("💥 place_order:", result.error);
        showErrorToast(tr("failedToPlaceOrderTryAgain"));
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      const data = result.data;
      console.log("📋 place_order response:", JSON.stringify(data, null, 2));

      const normalized = normalizePlaceOrderResponse(data);

      if (!result.ok) {
        const msg = normalized.message || "Failed to place order";
        showErrorToast(msg);
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      const message = normalized.message || "";
      const rmsResponseCode = normalized.rmsResponseCode;
      const brokerOrderID = normalized.brokerOrderID;
      const exchangeOrderID = normalized.exchangeOrderID;

      if (
        isFivePaisaBroker(sharedData) &&
        (rmsResponseCode === -162 ||
          message.toLowerCase().includes("sell authorization not received") ||
          message.toLowerCase().includes("authorization not received"))
      ) {
        showErrorToast(tr("cdslAuthorizationRequired"));
        if (transactionSide === "Buy") {
          document.getElementById("buyModalClick")?.click();
        } else if (transactionSide === "Sell") {
          document.getElementById("sellModalClick")?.click();
        }
        setTimeout(() => {
          document.getElementById("openCDSLModalBtn")?.click();
        }, 500);
        return;
      }

      if (normalized.headStatus !== "0") {
        showErrorToast(message || tr("failedToPlaceOrder"));
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      runPlaceOrderAcceptedFlow({
        transactionSide,
        tr,
        showSuccessToast,
        navigate,
      });
    });

    console.log(
      "🏁 clickPlaceOrderPortfolio - Function end (async PMS call continues)",
    );
  };

  // const refreshHoldings = () => {
  //   console.log("🔄 Starting holdings refresh...");

  //   const holdingsRefreshData = {
  //     AccessToken: sharedData.AccessToken,
  //     ClientCode: sharedData.ClientCode,
  //     api_key: sharedData.api_key,
  //     userId: sharedData.ID,
  //   };

  //   console.log("📦 Holdings refresh request data:", holdingsRefreshData);

  //   fetch("https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=getHoldingData", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(holdingsRefreshData),
  //   })
  //     .then((res) => {
  //       console.log("📥 Holdings refresh response received");
  //       console.log("✅ Holdings refresh status:", res.status);
  //       console.log("🔗 Holdings refresh OK:", res.ok);
  //       return res.json();
  //     })
  //     .then((holdingsData) => {
  //       console.log("✅ Holdings refreshed successfully");
  //       console.log("📊 Updated holdings data:", holdingsData);
  //     })
  //     .catch((err) => {
  //       console.error("💥 Error refreshing holdings:");
  //       console.error("❌ Holdings refresh error:", err);
  //     });
  // };

  const refreshHoldings = () => {
    console.log("🔄 Starting holdings refresh...");



  };

  const updateMargin = () => {
    console.log("💰 updateMargin - Starting margin update");

    // Get sharedData from localStorage
    const saved = JSON.parse(localStorage.getItem("sharedData"));

    if (!saved || !saved.accessToken || !saved.api_key || !saved.ClientCode) {
      console.error("❌ Missing required data for margin update");
      return;
    }

    const apiUrl = "https://Openapi.5paisa.com/VendorsAPI/Service1.svc/V4/Margin";
    console.log("🌐 Margin API URL:", apiUrl);

    const requestBody = {
      head: {
        key: saved.api_key
      },
      body: {
        ClientCode: saved.ClientCode
      }
    };

    console.log("📦 Margin request body:", requestBody);

    const requestHeaders = {
      "Authorization": `Bearer ${saved.accessToken}`,
      "Content-Type": "application/json"
    };

    console.log("📤 Sending margin update request...");

    fetch(apiUrl, {
      method: "POST",
      headers: requestHeaders,
      body: JSON.stringify(requestBody)
    })
      .then((response) => {
        console.log("📥 Margin API response received");
        console.log("✅ Response status:", response.status);

        if (!response.ok) {
          console.error("❌ Margin API response not OK");
          throw new Error("Margin API response was not ok");
        }

        return response.json();
      })
      .then((data) => {
        console.log("📋 Margin API Response Data:");
        console.log(JSON.stringify(data, null, 2));

        // Extract NetAvailableMargin from response
        const equityMargin = data.body?.EquityMargin?.[0];

        if (equityMargin && equityMargin.NetAvailableMargin !== undefined) {
          const netAvailableMargin = equityMargin.NetAvailableMargin;
          console.log("💵 NetAvailableMargin:", netAvailableMargin);

          // Update sharedData in localStorage
          const currentSharedData = JSON.parse(localStorage.getItem("sharedData"));
          currentSharedData.margin = netAvailableMargin;

          localStorage.setItem("sharedData", JSON.stringify(currentSharedData));
          console.log("✅ Margin updated in localStorage:", netAvailableMargin);

          // 🆕 Optional: Update state if you have margin in component state
          // setSharedData(currentSharedData); // Uncomment if you use state

          // Show success toast
          console.log("💰 Available Margin: ₹" + netAvailableMargin.toFixed(2));

        } else {
          console.error("❌ NetAvailableMargin not found in response");
          console.error("📊 EquityMargin data:", equityMargin);
        }
      })
      .catch((error) => {
        console.error("💥 Margin API call failed:");
        console.error("❌ Error type:", error.name);
        console.error("❌ Error message:", error.message);
        console.error("📊 Full error object:", error);
      });

    console.log("🏁 updateMargin - Function end (async call continues)");
  };





  const getPriceForCalculation = () => {
    if (orderType === "Market Order") {
      const cacheKey = getOrderLivePriceCacheKey(buySellModalDetails.order);
      const livePrice = livePriceCache.current[cacheKey];
      return livePrice || buySellModalDetails.order?.CurrentPrice || buySellModalDetails.order?.initialPrice || 0;
    } else {
      // Use limit price for Limit orders
      return buySellModalDetails.LimitPrice || 0;
    }
  };







  //----------------------------// End Buy-Sell Functions //----------------------------//`



  //----------------------------//  Market Depth Functions //----------------------------//`
  // Function to subscribe to MarketDepth for a given stock
  // 🔥 Subscribe to Market Depth (Order Book) for a stock
  const subscribeToMarketDepth = (holding) => {
    if (!holding) return;
    fivePaisaMarketDepthStore.openDepth(holding);
  };



  const unsubscribeFromMarketDepth = () => {
    fivePaisaMarketDepthStore.closeDepth();
  };




  // Function to run when modal closes

  const handleModalClose = () => {
    console.log("📉📉📉 MarketDepth modal closed!");

    if (currentMDModalRef.current) {
      console.log("📉 Unsubscribing to:", currentMDModalRef.current);
      unsubscribeFromMarketDepth();
      console.log("📉 Unsubscribed");

      // Clear the ref so it doesn't hold stale data
      currentMDModalRef.current = null;
      setcurrentMDModal(null);
      setMarketDepth([]);
    }
    setShowMarketDepth(false);
  };

  // Handle Market Depth click with positioning
  const handleMarketDepthClick = (stock, e) => {
    const button = e.currentTarget;
    const buttonRect = button.getBoundingClientRect();

    const popoverWidth = 480;
    const popoverHeight = 500;
    const padding = 16;

    let left = buttonRect.left - popoverWidth - 12;
    let top = buttonRect.top - 20;

    if (left < padding) {
      left = buttonRect.right + 12;
    }

    if (top < padding) {
      top = buttonRect.top + buttonRect.height + 12;
    }

    if (top + popoverHeight > window.innerHeight - padding) {
      top = window.innerHeight - popoverHeight - padding;
    }

    if (left + popoverWidth > window.innerWidth - padding) {
      left = window.innerWidth - popoverWidth - padding;
    }

    setMarketDepthPosition({
      top: Math.max(padding, top),
      left: Math.max(padding, left),
    });
    setShowMarketDepth(true);
    currentMDModalRef.current = stock;
    setcurrentMDModal(stock);
    subscribeToMarketDepth(stock);
  };








  //----------------------------// End market Depth Functions //----------------------------//`

  const renderSearchStockRowActions = (stock) => (
    <ul className="table__action_hover">
      <li>
        <div className="buy-sell-segmented">
          <button
            className="btn_buy wl-premium-action-btn wl-premium-buy"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#BuySellModal1"
            onClick={() => SettingBuyModalDetails(stock, "Buy")}
          >
            {tr("buy")}
          </button>
          <button
            className="btn_sell wl-premium-action-btn wl-premium-sell"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#BuySellModal1"
            onClick={() => SettingBuyModalDetails(stock, "Sell")}
          >
            {tr("sell")}
          </button>
        </div>
      </li>
      {!isGrowBroker && !isAngelOneBroker && (
        <Whisper
          placement="top"
          trigger="hover"
          speaker={<Tooltip className="common__tooltip">{tr("marketDepth")}</Tooltip>}
        >
          <li>
            <button
              ref={marketDepthButtonRef}
              onClick={(e) => handleMarketDepthClick(stock, e)}
              className="btn_trading wl-premium-action-btn wl-premium-depth"
              style={{
                width: "38px",
                height: "34px",
                borderRadius: "8px",
                border: "none",
                background: "transparent",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
              }}
            >
              <MarketDepthIcon />
            </button>
          </li>
        </Whisper>
      )}
      <Whisper
        placement="top"
        trigger="hover"
        speaker={<Tooltip className="common__tooltip">{tr("addToWatchlist")}</Tooltip>}
      >
        <li>
          <button
            data-bs-toggle="modal"
            data-bs-target="#selectWatchlistModal"
            style={{
              height: "34px",
              width: "38px",
              minWidth: "38px",
              padding: 0,
              borderRadius: "8px",
              border: "none",
              background: "transparent",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: isAddWatchlistDisabled ? "not-allowed" : "pointer",
              opacity: isAddWatchlistDisabled ? 0.6 : 1,
              boxShadow: "none",
              marginRight: "10px",
            }}
            className="wl-premium-action-btn wl-premium-add-watchlist"
            onClick={() => {
              setIsAddWatchlistDisabled(true);
              setSelectedStockToAdd(stock);
              fetchUserWatchlistsForHeader();
              setTimeout(() => setIsAddWatchlistDisabled(false), 2000);
            }}
            disabled={isAddWatchlistDisabled}
          >
            <FaHeartCirclePlus className="add-watchlist-heart-icon" />
          </button>
        </li>
      </Whisper>
    </ul>
  );

  const renderSearchSampleRowActions = () => (
    <ul className="table__action_hover">
      <li>
        <div className="buy-sell-segmented">
          <button
            className="btn_buy wl-premium-action-btn wl-premium-buy"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#BuySellModal"
          >
            {tr("buy")}
          </button>
          <button
            className="btn_sell wl-premium-action-btn wl-premium-sell"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#BuySellModal"
          >
            {tr("sell")}
          </button>
        </div>
      </li>
      {!isGrowBroker && !isAngelOneBroker && (
        <Whisper
          placement="top"
          trigger="hover"
          speaker={<Tooltip className="common__tooltip">{tr("marketDepth")}</Tooltip>}
        >
          <li>
            <button
              type="button"
              disabled
              className="btn_trading wl-premium-action-btn wl-premium-depth"
              style={{
                width: "38px",
                height: "34px",
                borderRadius: "8px",
                border: "none",
                background: "transparent",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
                opacity: 0.45,
                cursor: "not-allowed",
              }}
            >
              <MarketDepthIcon />
            </button>
          </li>
        </Whisper>
      )}
      <Whisper
        placement="top"
        trigger="hover"
        speaker={<Tooltip className="common__tooltip">{tr("addToWatchlist")}</Tooltip>}
      >
        <li>
          <button
            type="button"
            disabled
            className="wl-premium-action-btn wl-premium-add-watchlist"
            style={{
              height: "34px",
              width: "38px",
              minWidth: "38px",
              padding: 0,
              borderRadius: "8px",
              border: "none",
              background: "transparent",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: 0.45,
              cursor: "not-allowed",
              boxShadow: "none",
              marginRight: "10px",
            }}
          >
            <FaHeartCirclePlus className="add-watchlist-heart-icon" />
          </button>
        </li>
      </Whisper>
    </ul>
  );

  return (
    <>

      <MarketBanner />

      <div id="header" className={scrolled ? "header_sticky" : ""}>
        <div className="header__left_col">
          {/* Logo */}
          <div className="logo">
            {/* <div className="logo_icon w-8 h-8">
              <img src={Logo} alt="logo" />
            </div>
            <div className="brand_name font-bold text-lg">Infomanav</div> */}
            <img src={Logo} alt="logo" style={{ height: "30px" }} />
          </div>

          <div ref={dropdownRef} className="searchbox_wrap">
            <div className={`searchbox ${isActive ? "active" : ""}`}>
              <button className="text-gray-500">
                <i className="icon-search"></i>
              </button>
              <input
                type="text"
                value={query}
                // onChange={(e) => setQuery(e.target.value)}
                placeholder={tr("searchStockPlaceholder")}
                className=""

                onChange={(e) => {
                  const inputValue = e.target.value;
                  setQuery(inputValue);

                  // Trigger debounced search
                  debouncedSearch(inputValue);

                  if (inputValue) {
                    setIsActive(true);
                  } else {
                    clearSearch();
                  }
                }}

                onFocus={() => setIsActive(true)}
                onBlur={() => {
                  if (!query) setIsActive(false);
                }}
              />
              {query && (
                // X Button Cross button
                <button onClick={() => {
                  clearSearch();
                }} className="btn_search_clear">

                  <i className="icon-cross"></i>
                </button>
              )}
            </div>

            {/* Dropdown */}
            <AnimatePresence>
              {query && (
                <motion.div
                  className="searchbar_main mt-2"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.25 }}
                >
                  {/* <div className="mt-2" style={{ maxHeight: '600px', overflowY: 'auto' }}> */}
                  <div className="mt-2" style={{ maxHeight: '600px', display: 'flex', flexDirection: 'column' }}>


                    {/* Tabs */}
                    <div className="search__tab">
                      <button
                        className={activeTab === "stocks" ? "tab active" : "tab"}
                        onClick={() => setActiveTab("stocks")}
                      >
                        {tr("allStocks")}
                      </button>

                      <button
                        className={activeTab === "BSE" ? "tab active" : "tab"}
                        onClick={() => setActiveTab("BSE")}
                      >
                        BSE
                      </button>

                      <button
                        className={activeTab === "NSE" ? "tab active" : "tab"}
                        onClick={() => setActiveTab("NSE")}
                      >
                        NSE
                      </button>

                      {!isGrowBroker && (
                        <button
                          className={activeTab === "MCX" ? "tab active" : "tab"}
                          onClick={() => setActiveTab("MCX")}
                        >
                          MCX
                        </button>
                      )}

                      {/* Search Tip */}
                      <div className="search-tip-badge">

                        <span>
                          {tr("searchTipText")}
                        </span>
                      </div>

                    </div>


                    {/* Results Table */}
                    <div className="table-responsive" style={{ flex: 1, overflowY: 'auto', overflowX: 'auto', minHeight: 0 }}>

                      {activeTab === "stocks" && (
                        <table className="table">
                          <thead
                            style={{ position: 'sticky', top: -1, zIndex: 1 }}
                          >
                            <tr className=""
                              style={{ borderBottom: '1px solid #ddd', zIndex: 2 }}
                            >
                              {/* <th>&nbsp;</th> */}
                              {/* <th className="py-2" style={{ textAlign: 'center' }}>Symbol</th> */}
                              <th style={{ fontWeight: "600", fontSize: "18px", width: "420px", paddingLeft: "35px" }} >{tr("name")}</th>
                              <th style={{ fontWeight: "600", fontSize: "18px", textAlign: 'center' }}>{tr("currentValue")}</th>
                              <th style={{ fontWeight: "600", fontSize: "18px", textAlign: 'center' }}>{tr("netChange")}</th>
                              {/* <th style={{ textAlign: 'right' }}>Market Cap</th> */}
                              {/* <th style={{ paddingLeft: 0, paddingRight: 0 }}></th> */}
                            </tr>
                          </thead>


                          <tbody>
                            {query.length > 0 && searchResults.length > 0 ? (
                              // Show search results when available with sorting
                              searchResults
                                .sort((a, b) => {
                                  const priceA = livePriceCache.current?.[a.Scripcode];
                                  const priceB = livePriceCache.current?.[b.Scripcode];

                                  // Check if prices are available and greater than 0
                                  const hasValidPriceA = priceA !== undefined && priceA !== null && priceA > 0;
                                  const hasValidPriceB = priceB !== undefined && priceB !== null && priceB > 0;

                                  // Sort: valid prices first, then unavailable
                                  if (hasValidPriceA && !hasValidPriceB) return -1;
                                  if (!hasValidPriceA && hasValidPriceB) return 1;
                                  return 0;
                                })
                                .map((stock, index) => {
                                  const exchange = stock.Exch === 'B' ? 'BSE' : stock.Exch === 'N' ? 'NSE' : 'MCX';

                                  // 🔥 Get live price data using Scripcode as key
                                  const livePrice = livePriceCache.current?.[stock.Scripcode];

                                  // Keep existing (for 5paisa)
                                  let liveDiff = liveDiffCache.current?.[stock.Scripcode];
                                  let liveChangePercent = liveChangePercentageCache.current?.[stock.Scripcode];

                                  // 🔥 FIX FOR GROW ONLY
                                  if (brokerTypeRaw === "grow") {
                                    const prevClose = Number(stock.PrevClose);

                                    if (
                                      livePrice !== undefined &&
                                      livePrice !== null &&
                                      livePrice > 0 &&
                                      prevClose > 0
                                    ) {
                                      liveDiff = livePrice - prevClose;
                                      liveChangePercent = (liveDiff / prevClose) * 100;
                                    }
                                  }

                                  // Check if live price is available
                                  const isPriceAvailable = livePrice !== undefined && livePrice !== null && livePrice > 0;

                                  // Determine price color and arrow direction
                                  const priceColor = liveDiff > 0 ? 'text_success_color' : liveDiff < 0 ? 'text_danger_color' : 'text_secondary_color';
                                  const arrowIcon = liveDiff > 0 ? 'icon-arrow-up' : 'icon-arrow-down';

                                  return (
                                    <tr key={index} style={{ opacity: isPriceAvailable ? 1 : 0.6 }}>
                                      <td>
                                        <div className="table_table_cname_row">
                                          <h5
                                            style={{ fontWeight: "500", fontSize: "17px", paddingBottom: "5px" }}
                                          >{stock.FullName || stock.Name}</h5>
                                          <div style={{ display: "flex", gap: 3, fontSize: "14px" }}  >
                                            <span style={{ display: "flex", gap: 3, fontSize: "13px" }} >{exchange}</span>
                                            <span style={{ display: "flex", gap: 3, fontSize: "13px" }} className="tag_symbol">{stock.Name}</span>
                                          </div>
                                        </div>
                                      </td>


                                      <td style={{ textAlign: 'center' }}>
                                        <div
                                          className={isPriceAvailable ? priceColor : ''}
                                          style={{
                                            fontSize: "17px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "62px",
                                            color: !isPriceAvailable ? '#6c757d' : undefined
                                          }}
                                        >
                                          <p style={{ paddingTop: "10px" }}>
                                            {isPriceAvailable ? (
                                              <>
                                                ₹{formatNumber(livePrice.toFixed(2))}
                                                {liveDiff !== undefined && liveDiff !== null && <i className={arrowIcon} style={{ marginLeft: '4px' }}></i>}
                                              </>
                                            ) : (
                                              tr("unavailable")
                                            )}
                                          </p>
                                        </div>
                                      </td>


                                      <td style={{ textAlign: 'center' }}>
                                        <div
                                          className={isPriceAvailable ? priceColor : ''}
                                          style={{
                                            fontSize: "17px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "62px",
                                            color: !isPriceAvailable ? '#6c757d' : undefined
                                          }}
                                        >
                                          <p style={{ paddingTop: "10px" }}>
                                            {isPriceAvailable && liveDiff !== undefined && liveDiff !== null && liveChangePercent !== undefined && liveChangePercent !== null
                                              ? `${formatNumber(liveDiff.toFixed(2))} (${liveChangePercent.toFixed(2)}%)`
                                              : '—'}
                                          </p>
                                        </div>
                                      </td>

                                      {renderSearchStockRowActions(stock)}
                                    </tr>
                                  );
                                })
                            ) : query.length > 0 ? (
                              // Show "No data found" when user is searching but no results
                              <tr>
                                <td colSpan="3" className="search-empty-cell">
                                  <div className="search-empty-state">
                                    <i className="icon-search"></i>
                                    <div className="search-empty-title">
                                      {query.length < 3
                                        ? tr("pleaseEnterAtLeast3Chars")
                                        : tr("noStocksFoundMatchingSearch")}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              // Show default content when no search query (empty input)
                              <>
                                <tr>
                                  <td>
                                    <div className="table_table_cname_row">
                                      <h5>{tr("sampleStockName")}</h5>
                                      <div style={{ display: "flex", gap: 3 }} >
                                        <span>{tr("sampleExchange")}</span>
                                        <span className="tag_symbol">AAPL</span>
                                      </div>
                                    </div>
                                  </td>
                                  <td style={{ textAlign: 'center' }}>
                                    <div className="trade__price__cell text_danger_color">-1.48 <i className="icon-arrow-down"></i></div>
                                  </td>
                                  <td style={{ textAlign: 'center' }}>₹172.50</td>
                                  <td>{renderSearchSampleRowActions()}</td>
                                </tr>
                              </>
                            )}
                          </tbody>




                        </table>
                      )}

                      {activeTab === "BSE" && (
                        <table className="table">
                          <thead
                            style={{ position: 'sticky', top: -1, zIndex: 1 }}
                          >
                            <tr className=""
                              style={{ borderBottom: '1px solid #ddd', zIndex: 2 }}
                            >
                              {/* <th>&nbsp;</th> */}
                              {/* <th className="py-2" style={{ textAlign: 'center' }}>Symbol</th> */}
                              <th style={{ fontWeight: "600", fontSize: "18px", width: "420px", paddingLeft: "35px" }} >{tr("name")}</th>
                              <th style={{ fontWeight: "600", fontSize: "18px", textAlign: 'center' }}>{tr("currentValue")}</th>
                              <th style={{ fontWeight: "600", fontSize: "18px", textAlign: 'center' }}>{tr("netChange")}</th>
                              {/* <th style={{ textAlign: 'right' }}>Market Cap</th> */}
                              {/* <th style={{ paddingLeft: 0, paddingRight: 0 }}></th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {query.length > 0 ? (
                              (() => {
                                const bseStocks = searchResults.filter(stock => stock.Exch === 'B');
                                if (bseStocks.length === 0) {
                                  return (
                                    <tr>
                                      <td colSpan="3" className="table-empty-state-cell">
                                        <span className="table-empty-order-text">
                                          {tr("noBSEStockMatchFound")}
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                }
                                return bseStocks
                                  .sort((a, b) => {
                                    const priceA = livePriceCache.current?.[a.Scripcode];
                                    const priceB = livePriceCache.current?.[b.Scripcode];

                                    // Check if prices are available and greater than 0
                                    const hasValidPriceA = priceA !== undefined && priceA !== null && priceA > 0;
                                    const hasValidPriceB = priceB !== undefined && priceB !== null && priceB > 0;

                                    // Sort: valid prices first, then unavailable
                                    if (hasValidPriceA && !hasValidPriceB) return -1;
                                    if (!hasValidPriceA && hasValidPriceB) return 1;
                                    return 0;
                                  })
                                  .map((stock, index) => {
                                    const exchange = stock.Exch === 'B' ? 'BSE' : stock.Exch === 'N' ? 'NSE' : 'MCX';


                                    // Get live price data using Scripcode as key
                                    const livePrice = livePriceCache.current?.[stock.Scripcode];

                                    // Keep existing (for 5paisa)
                                    let liveDiff = liveDiffCache.current?.[stock.Scripcode];
                                    let liveChangePercent = liveChangePercentageCache.current?.[stock.Scripcode];
                                    
                                    // 🔥 FIX FOR GROW ONLY
                                    if (brokerTypeRaw === "grow") {
                                      const prevClose = Number(stock.PrevClose);
                                    
                                      if (
                                        livePrice !== undefined &&
                                        livePrice !== null &&
                                        livePrice > 0 &&
                                        prevClose > 0
                                      ) {
                                        liveDiff = livePrice - prevClose;
                                        liveChangePercent = (liveDiff / prevClose) * 100;
                                      }
                                    }

                                    // Check if live price is available
                                    const isPriceAvailable = livePrice !== undefined && livePrice !== null && livePrice > 0;

                                    // Determine price color and arrow direction
                                    const priceColor = liveDiff > 0 ? 'text_success_color' : liveDiff < 0 ? 'text_danger_color' : 'text_secondary_color';
                                    const arrowIcon = liveDiff > 0 ? 'icon-arrow-up' : 'icon-arrow-down';


                                    return (
                                      <tr key={index} style={{ opacity: isPriceAvailable ? 1 : 0.6 }}>
                                        <td>
                                          <div className="table_table_cname_row">
                                            <h5 style={{ fontWeight: "500", fontSize: "17px", paddingBottom: "5px" }}>
                                              {stock.FullName || stock.Name}
                                            </h5>
                                            <div style={{ display: "flex", gap: 3, fontSize: "14px" }}>
                                              <span style={{ display: "flex", gap: 3, fontSize: "13px" }}>{exchange}</span>
                                              <span style={{ display: "flex", gap: 3, fontSize: "13px" }} className="tag_symbol">{stock.Name}</span>
                                            </div>
                                          </div>
                                        </td>


                                        <td style={{ textAlign: 'center' }}>
                                          <div
                                            className={isPriceAvailable ? priceColor : ''}
                                            style={{
                                              fontSize: "17px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "62px",
                                              color: !isPriceAvailable ? '#6c757d' : undefined
                                            }}
                                          >
                                            <p style={{ paddingTop: "10px" }}>
                                              {isPriceAvailable ? (
                                                <>
                                                  ₹{formatNumber(livePrice.toFixed(2))}
                                                  {liveDiff !== undefined && liveDiff !== null && <i className={arrowIcon} style={{ marginLeft: '4px' }}></i>}
                                                </>
                                              ) : (
                                                tr("unavailable")
                                              )}
                                            </p>
                                          </div>
                                        </td>


                                        <td style={{ textAlign: 'center' }}>
                                          <div
                                            className={isPriceAvailable ? priceColor : ''}
                                            style={{
                                              fontSize: "17px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "62px",
                                              color: !isPriceAvailable ? '#6c757d' : undefined
                                            }}
                                          >
                                            <p style={{ paddingTop: "10px" }}>
                                              {isPriceAvailable && liveDiff !== undefined && liveDiff !== null && liveChangePercent !== undefined && liveChangePercent !== null
                                                ? `${formatNumber(liveDiff.toFixed(2))} (${liveChangePercent.toFixed(2)}%)`
                                                : '—'}
                                            </p>
                                          </div>
                                        </td>


                                        {renderSearchStockRowActions(stock)}
                                      </tr>
                                    );
                                  });
                              })()
                            ) : (
                              // Default content for empty query here
                              <>
                                {/* Add your default static rows here */}
                              </>
                            )}
                          </tbody>


                        </table>
                      )}

                      {activeTab === "NSE" && (
                        <table className="table">
                          <thead
                            style={{ position: 'sticky', top: -1, zIndex: 1 }}
                          >
                            <tr className=""
                              style={{ borderBottom: '1px solid #ddd', zIndex: 2 }}
                            >
                              {/* <th>&nbsp;</th> */}
                              {/* <th className="py-2" style={{ textAlign: 'center' }}>Symbol</th> */}
                              <th style={{ fontWeight: "600", fontSize: "18px", width: "420px", paddingLeft: "35px" }} >{tr("name")}</th>
                              <th style={{ fontWeight: "600", fontSize: "18px", textAlign: 'center' }}>{tr("currentValue")}</th>
                              <th style={{ fontWeight: "600", fontSize: "18px", textAlign: 'center' }}>{tr("netChange")}</th>
                              {/* <th style={{ textAlign: 'right' }}>Market Cap</th> */}
                              {/* <th style={{ paddingLeft: 0, paddingRight: 0 }}></th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {query.length > 0 ? (
                              (() => {
                                const nseStocks = searchResults.filter(stock => stock.Exch === 'N');
                                if (nseStocks.length === 0) {
                                  return (
                                    <tr>
                                      <td colSpan="3" className="table-empty-state-cell">
                                        <span className="table-empty-order-text">
                                          {tr("noNSEStockMatchFound")}
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                }
                                return nseStocks
                                  .sort((a, b) => {
                                    const priceA = livePriceCache.current?.[a.Scripcode];
                                    const priceB = livePriceCache.current?.[b.Scripcode];

                                    // Check if prices are available and greater than 0
                                    const hasValidPriceA = priceA !== undefined && priceA !== null && priceA > 0;
                                    const hasValidPriceB = priceB !== undefined && priceB !== null && priceB > 0;

                                    // Sort: valid prices first, then unavailable
                                    if (hasValidPriceA && !hasValidPriceB) return -1;
                                    if (!hasValidPriceA && hasValidPriceB) return 1;
                                    return 0;
                                  })
                                  .map((stock, index) => {
                                    const exchange = stock.Exch === 'B' ? 'BSE' : stock.Exch === 'N' ? 'NSE' : 'MCX';


                                    // Get live price data using Scripcode as key
                                    const livePrice = livePriceCache.current?.[stock.Scripcode];

                                    // Keep existing (for 5paisa)
                                    let liveDiff = liveDiffCache.current?.[stock.Scripcode];
                                    let liveChangePercent = liveChangePercentageCache.current?.[stock.Scripcode];

                                    // 🔥 FIX FOR GROW ONLY
                                    if (brokerTypeRaw === "grow") {
                                      const prevClose = Number(stock.PrevClose);

                                      if (
                                        livePrice !== undefined &&
                                        livePrice !== null &&
                                        livePrice > 0 &&
                                        prevClose > 0
                                      ) {
                                        liveDiff = livePrice - prevClose;
                                        liveChangePercent = (liveDiff / prevClose) * 100;
                                      }
                                    }

                                    // Check if live price is available
                                    const isPriceAvailable = livePrice !== undefined && livePrice !== null && livePrice > 0;

                                    // Determine price color and arrow direction
                                    const priceColor = liveDiff > 0 ? 'text_success_color' : liveDiff < 0 ? 'text_danger_color' : 'text_secondary_color';
                                    const arrowIcon = liveDiff > 0 ? 'icon-arrow-up' : 'icon-arrow-down';


                                    return (
                                      <tr key={index} style={{ opacity: isPriceAvailable ? 1 : 0.6 }}>
                                        <td>
                                          <div className="table_table_cname_row">
                                            <h5 style={{ fontWeight: "500", fontSize: "17px", paddingBottom: "5px" }}>
                                              {stock.FullName || stock.Name}
                                            </h5>
                                            <div style={{ display: "flex", gap: 3, fontSize: "14px" }}>
                                              <span style={{ display: "flex", gap: 3, fontSize: "13px" }}>{exchange}</span>
                                              <span style={{ display: "flex", gap: 3, fontSize: "13px" }} className="tag_symbol">{stock.Name}</span>
                                            </div>
                                          </div>
                                        </td>


                                        <td style={{ textAlign: 'center' }}>
                                          <div
                                            className={isPriceAvailable ? priceColor : ''}
                                            style={{
                                              fontSize: "17px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "62px",
                                              color: !isPriceAvailable ? '#6c757d' : undefined
                                            }}
                                          >
                                            <p style={{ paddingTop: "10px" }}>
                                              {isPriceAvailable ? (
                                                <>
                                                  ₹{formatNumber(livePrice.toFixed(2))}
                                                  {liveDiff !== undefined && liveDiff !== null && <i className={arrowIcon} style={{ marginLeft: '4px' }}></i>}
                                                </>
                                              ) : (
                                                tr("unavailable")
                                              )}
                                            </p>
                                          </div>
                                        </td>


                                        <td style={{ textAlign: 'center' }}>
                                          <div
                                            className={isPriceAvailable ? priceColor : ''}
                                            style={{
                                              fontSize: "17px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "62px",
                                              color: !isPriceAvailable ? '#6c757d' : undefined
                                            }}
                                          >
                                            <p style={{ paddingTop: "10px" }}>
                                              {isPriceAvailable && liveDiff !== undefined && liveDiff !== null && liveChangePercent !== undefined && liveChangePercent !== null
                                                ? `${formatNumber(liveDiff.toFixed(2))} (${liveChangePercent.toFixed(2)}%)`
                                                : '—'}
                                            </p>
                                          </div>
                                        </td>


                                        {renderSearchStockRowActions(stock)}
                                      </tr>
                                    );
                                  });
                              })()
                            ) : (
                              // Default content for empty query here
                              <>
                                {/* Add your default static rows here */}
                              </>
                            )}
                          </tbody>


                        </table>
                      )}

                      {activeTab === "MCX" && (
                        <table className="table">
                          <thead
                            style={{ position: 'sticky', top: -1, zIndex: 1 }}
                          >
                            <tr className=""
                              style={{ borderBottom: '1px solid #ddd', zIndex: 2 }}
                            >
                              {/* <th>&nbsp;</th> */}
                              {/* <th className="py-2" style={{ textAlign: 'center' }}>Symbol</th> */}
                              <th style={{ fontWeight: "600", fontSize: "18px", width: "420px", paddingLeft: "35px" }} >{tr("name")}</th>
                              <th style={{ fontWeight: "600", fontSize: "18px", textAlign: 'center' }}>{tr("currentValue")}</th>
                              <th style={{ fontWeight: "600", fontSize: "18px", textAlign: 'center' }}>{tr("netChange")}</th>
                              {/* <th style={{ textAlign: 'right' }}>Market Cap</th> */}
                              {/* <th style={{ paddingLeft: 0, paddingRight: 0 }}></th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {query.length > 0 ? (
                              (() => {
                                const mcxStocks = searchResults.filter(stock => stock.Exch === 'M');
                                if (mcxStocks.length === 0) {
                                  return (
                                    <tr>
                                      <td colSpan="3" className="table-empty-state-cell">
                                        <span className="table-empty-order-text">
                                          {tr("noMCXStockMatchFound")}
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                }
                                return mcxStocks
                                  .sort((a, b) => {
                                    const priceA = livePriceCache.current?.[a.Scripcode];
                                    const priceB = livePriceCache.current?.[b.Scripcode];

                                    // Check if prices are available and greater than 0
                                    const hasValidPriceA = priceA !== undefined && priceA !== null && priceA > 0;
                                    const hasValidPriceB = priceB !== undefined && priceB !== null && priceB > 0;

                                    // Sort: valid prices first, then unavailable
                                    if (hasValidPriceA && !hasValidPriceB) return -1;
                                    if (!hasValidPriceA && hasValidPriceB) return 1;
                                    return 0;
                                  })
                                  .map((stock, index) => {
                                    const exchange = stock.Exch === 'B' ? 'BSE' : stock.Exch === 'N' ? 'NSE' : 'MCX';


                                    // Get live price data using Scripcode as key
                                    const livePrice = livePriceCache.current?.[stock.Scripcode];
                                    const liveDiff = liveDiffCache.current?.[stock.Scripcode];
                                    const liveChangePercent = liveChangePercentageCache.current?.[stock.Scripcode];

                                    // Check if live price is available
                                    const isPriceAvailable = livePrice !== undefined && livePrice !== null && livePrice > 0;

                                    // Determine price color and arrow direction
                                    const priceColor = liveDiff > 0 ? 'text_success_color' : liveDiff < 0 ? 'text_danger_color' : 'text_secondary_color';
                                    const arrowIcon = liveDiff > 0 ? 'icon-arrow-up' : 'icon-arrow-down';


                                    return (
                                      <tr key={index} style={{ opacity: isPriceAvailable ? 1 : 0.6 }}>
                                        <td>
                                          <div className="table_table_cname_row">
                                            <h5 style={{ fontWeight: "500", fontSize: "17px", paddingBottom: "5px" }}>
                                              {stock.FullName || stock.Name}
                                            </h5>
                                            <div style={{ display: "flex", gap: 3, fontSize: "14px" }}>
                                              <span style={{ display: "flex", gap: 3, fontSize: "13px" }}>{exchange}</span>
                                              <span style={{ display: "flex", gap: 3, fontSize: "13px" }} className="tag_symbol">{stock.Name}</span>
                                            </div>
                                          </div>
                                        </td>


                                        <td style={{ textAlign: 'center' }}>
                                          <div
                                            className={isPriceAvailable ? priceColor : ''}
                                            style={{
                                              fontSize: "17px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "62px",
                                              color: !isPriceAvailable ? '#6c757d' : undefined
                                            }}
                                          >
                                            <p style={{ paddingTop: "10px" }}>
                                              {isPriceAvailable ? (
                                                <>
                                                  ₹{formatNumber(livePrice.toFixed(2))}
                                                  {liveDiff !== undefined && liveDiff !== null && <i className={arrowIcon} style={{ marginLeft: '4px' }}></i>}
                                                </>
                                              ) : (
                                                tr("unavailable")
                                              )}
                                            </p>
                                          </div>
                                        </td>


                                        <td style={{ textAlign: 'center' }}>
                                          <div
                                            className={isPriceAvailable ? priceColor : ''}
                                            style={{
                                              fontSize: "17px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "62px",
                                              color: !isPriceAvailable ? '#6c757d' : undefined
                                            }}
                                          >
                                            <p style={{ paddingTop: "10px" }}>
                                              {isPriceAvailable && liveDiff !== undefined && liveDiff !== null && liveChangePercent !== undefined && liveChangePercent !== null
                                                ? `${formatNumber(liveDiff.toFixed(2))} (${liveChangePercent.toFixed(2)}%)`
                                                : '—'}
                                            </p>
                                          </div>
                                        </td>


                                        {renderSearchStockRowActions(stock)}
                                      </tr>
                                    );
                                  });
                              })()
                            ) : (
                              // Default content for empty query here
                              <>
                                {/* Add your default static rows here */}
                              </>
                            )}
                          </tbody>


                        </table>
                      )}
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>

        <ul className="header__right__col">

          <li>
            <div className="header-broker-hub" ref={brokerDropdownRef}>
            <button
  type="button"
  className={`header-broker-switcher header-broker-switcher--premium ${showBrokerDropdown ? "active" : ""}`}
  onClick={() => {
    if (brokersForDropdown.length > 1) {
      setShowBrokerDropdown((prev) => !prev);
    }
  }}
  disabled={isLoading || brokersForDropdown.length <= 1}
  aria-expanded={showBrokerDropdown}
  aria-haspopup="listbox"
  title={
    brokersForDropdown.length > 1
      ? "Switch broker"
      : `${activeBrokerDisplay.name} (active)`
  }
>
  <span className="header-broker-switcher__brand">
    <span className="header-broker-switcher__avatar">
      <UserRound size={13} strokeWidth={2.4} />
    </span>
    <span className="header-broker-switcher__name-text">
      {localStorage.getItem("account_name") || activeBrokerDisplay.name}
    </span>
  </span>

  {brokersForDropdown.length > 1 ? (
    <svg
      className="header-broker-switcher__chevron"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M1.5 3.25L5 6.75L8.5 3.25"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : null}
</button>

  {showBrokerDropdown && brokersForDropdown.length > 1 ? (
    <div className="broker-switch-panel" role="listbox" aria-label="Switch broker">
      <div className="broker-switch-panel__list">
        {brokersForDropdown.map((brokerItem) => {
          const flag = String(brokerItem?.broker_flag || "").toLowerCase();
          const display = getBrokerDisplay(flag);
          const isActive = flag === brokerTypeRaw;

          return (
            <button
              key={brokerItem?.user_broker_id || flag}
              type="button"
              role="option"
              aria-selected={isActive}
              className={isActive ? "broker-card broker-card--active" : "broker-card"}
              onClick={() => handleSwitchBroker(flag)}
              disabled={isActive || isLoading}
              title={isActive ? `${display.name} (active)` : `Switch to ${display.name}`}
            >
              {renderBrokerDropdownOption(flag, display, isActive)}
            </button>
          );
        })}
      </div>
    </div>
  ) : null}
</div>
          </li>

          <li>
            <MarketStatusIndicator />
          </li>
          {/* <button onClick={toggleTheme}>
            {theme === "light_body" ? "🌙" : "☀️"}
          </button> */}

          {/* Notification Icon / bell icon */}

          {/* <li className="notification_icon">
            <i className="icon-bell"></i>
            <span className="notification_badge"></span>
          </li> */}
          <li>
            <div className="header-language">
              <span className="header-language__label">{tr("language")}</span>
              <SelectPicker
                data={LANGUAGE_OPTIONS}
                value={currentLanguage}
                onChange={handleLanguageSelect}
                cleanable={false}
                searchable={false}
                placement="bottomEnd"
                menuStyle={{ zIndex: 9999 }}
                className="header-language__picker"
                placeholder={tr("selectLanguage")}
              />
            </div>
          </li>

          <li>
            <div className="header__user header-user-card">
              <div className="header__user_name">
                <h6>{tr("hello")}</h6>
                <h5>{displayFirstName}</h5>
              </div>
              {/* <div className="header_user_icon">
                <i className="icon-user"></i>
              </div> */}
              <div className="user_profile_dropdown" ref={dropdownRef2}>
                <button
                  type="button"
                  className={`header_user_icon ${showDropdown ? "active" : ""}`}
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <i className="icon-user"></i>
                </button>

                {showDropdown && (
                  <div className="profile_dropdown_menu profile_dropdown_menu--compact">
                    {/* Header separator */}
                    <div className="profile_dropdown_header">
                      {tr("account")}
                    </div>

                    {/* Change Password */}
                    <button
                      type="button"
                      onClick={handleChangePassword}
                      className="profile_dropdown_item"
                    >
                      <CgProfile />
                      {tr("changePassword")}
                    </button>

                    {/* Logout */}
                    <button
                      type="button"
                      // onClick={handleLogout}
                      onClick={handleLogoutClick}
                      className="profile_dropdown_item profile_dropdown_item--danger"
                    >
                      <FaPowerOff />
                      {tr("logout")}
                    </button>
                  </div>
                )}

              </div>
            </div>
          </li>
        </ul>
      </div>

      {isLoading && (
        <div style={{ backgroundColor: "rgba(17, 34, 0, 0)" }}>
          <Loader2

            color="#FCB633"
            opacity="0.5" />
        </div>
      )}





      {/* Buy Sell Modal */}
      <div ref={excludedButtonRef2} className="modal fade modal_md" id="BuySellModal1" aria-labelledby="BuySellModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header modal-header-modern"
              style={{
                backgroundColor: buySellModalDetails.Type === "Buy" ? "#F6FCF9" : "#fff7f7",
                border: `1px solid ${buySellModalDetails.Type === "Buy" ? "#B5E8CF" : "#F5B5B5"}`
              }}
            >
              <div className="modal-header-content">
                <div className="modal-title-wrapper">
                  <div className={`trading-type-badge ${buySellModalDetails.Type.toLowerCase()}`}>
                    <img
                      src={
                        buySellModalDetails.Type === "Buy"
                          ? ArrowTrendUp
                          : ArrowTrendDown
                      }
                      className="trading-icon"
                      alt="icon"
                    />
                    <span className="trading-type-text">{buySellModalDetails.Type}</span>
                  </div>
                  <h3 className="modal-title-modern">
                    {buySellModalDetails.Symbol}
                  </h3>
                </div>
                <button
                  type="button"
                  className="btn-close-modern"
                  data-bs-dismiss="modal"
                  aria-label={tr("close")}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>

            <div className="modal-body">
              <AnimatePresence mode="wait">
                {/* Screen 1 */}
                {!isPreview && (
                  <motion.div
                    key="screen1"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <div className="sell__content"
                      style={{
                        backgroundColor: buySellModalDetails.Type === "Buy" ? "#F6FCF9" : "#fff7f7",
                        border: `1px solid ${buySellModalDetails.Type === "Buy" ? "#B5E8CF" : "#F5B5B5"}`
                      }}
                    >
                      <div className="sell__content_inner d-flex justify-content-between align-items-center">
                        <div>
                          <h5 className="mb-0">{buySellModalDetails.Symbol}</h5>
                          <h6 className="mb-0">{buySellModalDetails.FullName}</h6>
                        </div>
                        {/* LivePrice/ Current Price */}
                        {/* LivePrice/ Current Price */}
                        <p className="mb-0">
                          {(() => {
                            const order = buySellModalDetails.order;
                            const cacheKey = getOrderLivePriceCacheKey(order);

                            const livePrice = livePriceCache.current[cacheKey];
                            const pClose = livePCloseCache.current[cacheKey];
                            const changePercent = liveChangePercentageCache.current[cacheKey];

                            // Fallback to different current price properties
                            const currentPrice = livePrice ||
                              order?.CurrentPrice ||
                              order?.LTP ||
                              order?.initialPrice ||
                              0;

                            const previousClose = pClose ||
                              order?.CurrentPrice ||
                              order?.LTP ||
                              order?.initialPrice ||
                              0;

                            const actualChangePercent = changePercent || 0;

                            // Calculate if price is positive (handle string/number comparison)
                            const currentPriceNum = parseFloat(currentPrice) || 0;
                            const previousCloseNum = parseFloat(previousClose) || 0;
                            const isPositive = currentPriceNum >= previousCloseNum;

                            return (
                              <>
                                ₹ {formatNumber(currentPriceNum)} <br />
                                <span className={isPositive ? "text-success" : "text-danger"}>
                                  ({isPositive ? '+' : ''}{typeof actualChangePercent === 'number' ? actualChangePercent.toFixed(2) : '0.00'}%)
                                  <i className={`icon-arrow-${isPositive ? 'up' : 'down'} ms-1`} style={{ fontSize: '0.8em' }}></i>
                                </span>
                              </>
                            );
                          })()}
                        </p>


                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', color: '#64748b', marginBottom: '6px' }}>{tr("orderType")}</label>
                        <SelectPicker
                          data={OrderType}
                          searchable={false}
                          container={document.body}
                          className="custom-select-picker"
                          value={orderType}
                          onChange={setOrderType}
                        />
                      </div>

                      {/* <div className="col-md-6">
                                          <label className="form-label">{tr("qty")}</label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={qty}
                                            onChange={(e) => setQty(Number(e.target.value))}
                                          />
                                        </div> */}
                      <div className="col-md-6">
                        <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', color: '#64748b', marginBottom: '6px' }}>{tr("qty")}</label>
                        <input
                          type="number"
                          className="form-control"
                          value={buySellModalDetails.OrderQty}
                          onChange={(e) => setBuySellModalDetails(prev => ({
                            ...prev,
                            OrderQty: Number(e.target.value)
                          }))}
                          style={{
                            width: "100%",
                            height: "40px",
                            borderRadius: "10px",
                            border: "1px solid #d5dfed",
                            padding: "10px 12px",
                            fontSize: "14px",
                            color: "#0f172a",
                            outline: "none",
                            boxShadow: "none"
                          }}
                        />
                      </div>

                    </div>

                    {/* {orderType === "Limit Order" && (
                                        <div className="mt-3">
                                          <label className="form-label">{tr("limitPrice")}</label>
                                          <input type="number" className="form-control" />
                                        </div>
                                      )} */}
                    {orderType === "Limit Order" && (
                      <div className="mt-3">
                        <label className="form-label">{tr("limitPrice")}</label>
                        <input
                          type="number"
                          className="form-control"
                          value={buySellModalDetails.LimitPrice}
                          onChange={(e) => setBuySellModalDetails(prev => ({
                            ...prev,
                            LimitPrice: Number(e.target.value)
                          }))}
                        />
                      </div>
                    )}



                    {buySellModalDetails.OrderQty > 0 && (
                      <motion.div
                        className="order-summary mt-4 p-3 border roundedX"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.4 }}
                        style={{
                          backgroundColor: buySellModalDetails.Type === "Buy" ? "#F6FCF9" : "#fff7f7",
                          border: `1px solid ${buySellModalDetails.Type === "Buy" ? "#B5E8CF" : "#F5B5B5"}`
                        }}
                      >
                        <h6 className="fw-bold mb-3">{tr("orderSummary")}</h6>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("orderType")}</span>
                          <span className="value">{orderType}</span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("quantity")}</span>
                          <span className="value">{buySellModalDetails.OrderQty} {tr("shares")}</span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("pricePerShare")}</span>
                          <span className="value">₹{formatNumber(getPriceForCalculation())}</span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("subtotal")}</span>
                          <span className="value">₹{formatNumber(buySellModalDetails.OrderQty * getPriceForCalculation())}</span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("estFees")}</span>
                          <span className="value">₹0.00</span>
                        </div>
                        <hr />
                        <div className="order-total d-flex justify-content-between fw-bold">
                          <span>{tr("totalAmount")}</span>
                          <span>₹{formatNumber(buySellModalDetails.OrderQty * getPriceForCalculation() + 0.00)}</span>
                        </div>
                      </motion.div>
                    )}


                  </motion.div>
                )}


                {/* Screen 2 */}
                {isPreview && (
                  <motion.div
                    key="screen2"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <div className="text-center mb-3">
                      <div className="preview_order_icon preview_buy_order_icon"
                        style={{ backgroundColor: buySellModalDetails.Type === "Buy" ? "#E1FBE9" : "#fff7f7" }}
                      >
                        {/* <img src={ArrowTrendDown} alt="icon" /> */}
                        <img
                          src={buySellModalDetails.Type === "Buy" ? ArrowTrendUp : ArrowTrendDown}
                          alt="icon"
                        />
                      </div>
                      <h5>{tr("confirmOrder")}</h5>
                      <p>{tr("pleaseReviewOrderDetails")}</p>
                    </div>

                    <div className="order-summary-content">
                      <div className="order-row">
                        <span className="label">{tr("orderType")}</span>
                        <span className="value">{orderType}</span>
                      </div>

                      <div className="order-row">
                        <span className="label">{tr("quantity")}</span>
                        <span className="value">{buySellModalDetails.OrderQty} {tr("shares")}</span>
                      </div>

                      <div className="order-row">
                        <span className="label">{tr("pricePerShare")}</span>
                        <span className="value">₹{formatNumber(getPriceForCalculation())}</span>
                      </div>

                      <div className="order-row">
                        <span className="label">{tr("subtotal")}</span>
                        <span className="value capitalize">
                          ₹{formatNumber(buySellModalDetails.OrderQty * getPriceForCalculation())}
                        </span>
                      </div>

                      <div className="order-row">
                        <span className="label">{tr("estFees")}</span>
                        <span className="value capitalize">₹0.00</span>
                      </div>

                      <div className="divider"></div>

                      <div className="order-total">
                        <span className="total-label">{tr("totalAmount")}</span>
                        <span className="total-value">
                          ₹{formatNumber(buySellModalDetails.OrderQty * getPriceForCalculation() + 0.00)}
                        </span>
                      </div>
                    </div>
                  </motion.div>
                )}

              </AnimatePresence>
            </div>

         
            <div className="modal-footer modal__footer_btn">
              {!isPreview ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    gap: "0.75rem",
                  }}
                >
                  <button
                    type="button"
                    className="btn-modern btn-secondary-modern"
                    data-bs-dismiss="modal"
                  >
                    {tr("cancel")}
                  </button>

                  <button
                    type="button"
                    className="btn-modern"
                    onClick={handlePreview}
                  >
                    {tr("previewOrder")}
                  </button>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      gap: "0.75rem",
                    }}
                  >
                    <button
                      type="button"
                      className="btn-modern btn-secondary-modern"
                      onClick={handleGoBack}
                    >
                      {tr("goBack")}
                    </button>

                    <button
                      type="button"
                      className={`btn-modern btn-success-modern ${buySellModalDetails.Type === 'Buy' ? 'buy' : 'sell'}`}
                      onClick={(e) => {
                        fetchDataPortfolio(buySellModalDetails.order, buySellModalDetails.Type, "Search")
                        e.target.disabled = true;
                        e.target.textContent = tr("processing");

                        setTimeout(() => {
                          setIsPreview(false); // or handleGoBack()
                          e.target.disabled = false;
                          e.target.textContent = tr("confirmOrder");
                        }, 1000);

                      }}

                      data-bs-dismiss="modal"
                    >
                      {tr("confirmOrder")}
                    </button>
                  </div>




                  {/* <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleGoBack}
                              >
                                Go Back
                              </button> */}



                  {/* <button 
                              type="button" 
                              className="btn btn-primary"
                              onClick={(e) => {
                                fetchDataPortfolio(buySellModalDetails.order, buySellModalDetails.Type, "Portfolio")
                                e.target.disabled = true;
                                e.target.textContent = "Processing...";
            
                                setTimeout(() => {
                                setIsPreview(false); // or handleGoBack()
                                e.target.disabled = false;
                                e.target.textContent = "Confirm Order";
                              }, 1000);
                              
                              }}
            
                              data-bs-dismiss="modal"
                              >
                                Confirm Order
                              </button> */}
                </>
              )}
            </div>
          </div>
        </div>
      </div>



      {/* Add to watchlist modal - Select Watchlist Modal - Professional Design */}
      <div className="modal fade" id="selectWatchlistModal" aria-labelledby="selectWatchlistModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{
              border: 'none',
              borderRadius: '16px',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.05)',
              overflow: 'hidden',
              backgroundColor: '#ffffff',
              maxWidth: '480px',
              margin: 'auto'
            }}
          >

            {/* Hidden close button for programmatic modal closing */}
            <button
              id="hiddenCloseSelectWatchlistModalBtn"
              type="button"
              data-bs-dismiss="modal"
              aria-label={tr("close")}
              style={{ display: 'none' }}
            />

            {/* Professional Header */}
            <div
              className="modal-header"
              style={{
                border: 'none',
                padding: '28px 32px 20px 32px',
                position: 'relative',
                backgroundColor: '#ffffff'
              }}
            >
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label={tr("close")}
                onClick={() => setSelectedStockToAdd(null)}
                style={{
                  position: 'absolute',
                  top: '24px',
                  right: '24px',
                  opacity: 0.5,
                  width: '24px',
                  height: '24px',
                  transition: 'opacity 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '1'}
                onMouseLeave={(e) => e.target.style.opacity = '0.5'}
              ></button>

              <div style={{ paddingRight: '40px' }}>
                <h2
                  style={{
                    margin: 0,
                    fontSize: '22px',
                    fontWeight: '700',
                    color: '#0f172a',
                    letterSpacing: '-0.4px',
                    lineHeight: '1.25'
                  }}
                >
                  Add to Watchlist
                </h2>
              </div>
            </div>

            <div className="modal-body" style={{ padding: '0 32px 28px 32px', backgroundColor: '#ffffff' }}>

              {/* Professional Stock Info Display */}
              {selectedStockToAdd && (
                <div style={{
                  padding: '16px 18px',
                  background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                  borderRadius: '12px',
                  marginBottom: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '14px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    background: 'linear-gradient(135deg, #2457BF 0%, #1a42a0 100%)',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#ffffff',
                    fontWeight: '700',
                    fontSize: '18px',
                    letterSpacing: '-0.3px',
                    flexShrink: 0,
                    boxShadow: '0 4px 12px rgba(36, 87, 191, 0.25)'
                  }}>
                    {selectedStockToAdd.Name?.charAt(0) || 'S'}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <h5 style={{
                      margin: '0 0 4px 0',
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#0f172a',
                      letterSpacing: '-0.2px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      {selectedStockToAdd.Name}
                    </h5>
                    <p style={{
                      margin: 0,
                      fontSize: '13px',
                      color: '#64748b',
                      fontWeight: '500',
                      letterSpacing: '-0.1px'
                    }}>
                      {selectedStockToAdd.Exch === 'N' ? 'NSE' : selectedStockToAdd.Exch === 'B' ? 'BSE' : selectedStockToAdd.Exch}
                      {selectedStockToAdd.ExchType === 'D' ? ' • Derivative' : ' • Cash'}
                    </p>
                  </div>
                </div>
              )}

              <p style={{
                fontSize: '14px',
                color: '#64748b',
                marginBottom: '16px',
                fontWeight: '500',
                letterSpacing: '-0.1px'
              }}>
                Select a watchlist
              </p>

              {/* Loading State */}
              {isLoadingWatchlists && (
                <div style={{
                  textAlign: 'center',
                  padding: '40px 20px'
                }}>
                  <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderWidth: '3px',
                      color: '#2457BF'
                    }}
                  >
                    <span className="visually-hidden">{tr("loading")}</span>
                  </div>
                  <p style={{
                    marginTop: '16px',
                    fontSize: '14px',
                    color: '#64748b',
                    fontWeight: '500'
                  }}>
                    Loading watchlists...
                  </p>
                </div>
              )}

              {/* No Watchlists State */}
              {!isLoadingWatchlists && headerUserWatchlists.length === 0 && (
                <div style={{
                  textAlign: 'center',
                  padding: '32px 20px',
                  backgroundColor: '#f8fafc',
                  borderRadius: '12px',
                  border: '1px dashed #cbd5e1'
                }}>
                  <p style={{
                    margin: '0 0 16px 0',
                    fontSize: '14px',
                    color: '#64748b',
                    fontWeight: '500'
                  }}>
                    No watchlists found
                  </p>
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#createNewWatchlistModalHeader"
                    data-bs-dismiss="modal"
                    style={{
                      padding: '10px 20px',
                      fontSize: '14px',
                      fontWeight: '600',
                      backgroundColor: '#2457BF',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'all 0.15s ease',
                      letterSpacing: '-0.2px'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#1a42a0';
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(36, 87, 191, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#2457BF';
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    Create Your First Watchlist
                  </button>
                </div>
              )}

              {/* Professional Watchlist Selection List */}
              {!isLoadingWatchlists && headerUserWatchlists.length > 0 && (
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  marginBottom: '20px'
                }}>
                  {headerWatchlistEntries.map((watchlist, index) => (
                    <button
                      key={watchlist.id || index}
                      type="button"
                      className="watchlist-select-btn"
                      onClick={() => handleAddToSpecificWatchlist(watchlist)}
                      style={{
                        padding: '14px 16px',
                        fontSize: '15px',
                        backgroundColor: '#ffffff',
                        color: '#0f172a',
                        border: '2px solid #e2e8f0',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        transition: 'all 0.15s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        fontWeight: '600',
                        letterSpacing: '-0.2px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f8fafc';
                        e.currentTarget.style.borderColor = '#2457BF';
                        e.currentTarget.style.color = '#2457BF';
                        const arrowIcon = e.currentTarget.querySelector('.arrow-icon');
                        if (arrowIcon) {
                          arrowIcon.style.transform = 'translateX(4px)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ffffff';
                        e.currentTarget.style.borderColor = '#e2e8f0';
                        e.currentTarget.style.color = '#0f172a';
                        const arrowIcon = e.currentTarget.querySelector('.arrow-icon');
                        if (arrowIcon) {
                          arrowIcon.style.transform = 'translateX(0)';
                        }
                      }}
                    >
                      <span>{watchlist.name}</span>
                      <svg
                        className="arrow-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        style={{
                          transition: 'transform 0.15s ease',
                          opacity: 0.6
                        }}
                      >
                        <path
                          d="M6 12L10 8L6 4"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  ))}
                </div>
              )}

              {/* Professional Divider */}
              {!isLoadingWatchlists && headerUserWatchlists.length > 0 && headerUserWatchlists.length < 5 && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '24px 0',
                  gap: '16px'
                }}>
                  <div style={{ flex: 1, height: '1px', backgroundColor: '#e2e8f0' }}></div>
                  <span style={{
                    fontSize: '12px',
                    color: '#94a3b8',
                    fontWeight: '600',
                    letterSpacing: '0.5px'
                  }}>
                    OR
                  </span>
                  <div style={{ flex: 1, height: '1px', backgroundColor: '#e2e8f0' }}></div>
                </div>
              )}

              {/* Create New Watchlist Button - Professional */}
              {!isLoadingWatchlists && headerUserWatchlists.length < 5 && (
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#createNewWatchlistModalHeader"
                  data-bs-dismiss="modal"
                  style={{
                    width: '100%',
                    padding: '13px 20px',
                    fontSize: '15px',
                    fontWeight: '600',
                    backgroundColor: '#ffffff',
                    color: '#2457BF',
                    border: '2px solid #2457BF',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    transition: 'all 0.15s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    letterSpacing: '-0.2px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#2457BF';
                    e.target.style.color = '#ffffff';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(36, 87, 191, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#ffffff';
                    e.target.style.color = '#2457BF';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 3V13M3 8H13"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  {tr("createNewWatchlist")}
                </button>
              )}

              {/* Max Limit Alert - Professional */}
              {!isLoadingWatchlists && headerUserWatchlists.length >= 5 && (
                <div style={{
                  padding: '14px 16px',
                  background: 'linear-gradient(135deg, #fffbf0 0%, #fff8e1 100%)',
                  borderRadius: '10px',
                  marginTop: '16px',
                  fontSize: '14px',
                  color: '#92400e',
                  border: '1px solid #fde68a',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontWeight: '500',
                  letterSpacing: '-0.1px'
                }}>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ minWidth: '18px' }}>
                    <path
                      d="M9 5V9M9 13H9.01M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
                      stroke="#D67A1F"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>{tr("maximum5WatchlistsReached")}</span>
                </div>
              )}

            </div>

          </div>
        </div>
      </div>









      {/* Create New Watchlist Modal - Header Version - Premium Design */}
      <div className="modal fade" id="createNewWatchlistModalHeader" aria-labelledby="createNewWatchlistModalHeaderLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{
              border: 'none',
              borderRadius: '16px',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
              overflow: 'hidden',
              backgroundColor: '#ffffff'
            }}
          >

            {/* Hidden close button for programmatic modal closing */}
            <button
              id="hiddenCloseCreateWatchlistModalBtn"
              type="button"
              data-bs-dismiss="modal"
              aria-label={tr("close")}
              style={{ display: 'none' }}
            />

            {/* Premium Header */}
            <div
              className="modal-header"
              style={{
                background: 'linear-gradient(135deg, #2457BF 0%, #1a42a0 100%)',
                border: 'none',
                padding: '24px 28px',
                position: 'relative'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    background: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path
                      d="M9 3V15M3 9H15"
                      stroke="#ffffff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: '20px',
                    fontWeight: '600',
                    color: '#ffffff',
                    letterSpacing: '-0.3px'
                  }}
                >
                  {tr("createNewWatchlist")}
                </h2>
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleCancelCreateWatchlist}
                aria-label={tr("close")}
                style={{
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.9,
                  width: '32px',
                  height: '32px',
                  background: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '8px',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = '1';
                  e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = '0.9';
                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                }}
              >
                <IoClose />
              </button>
            </div>

            <div className="modal-body" style={{ padding: '28px', backgroundColor: '#F2F7FD' }}>

              {/* Max watchlist limit error - Premium Design */}
              {headerUserWatchlists.length >= 5 && (
                <div
                  style={{
                    padding: '16px 18px',
                    background: 'linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%)',
                    borderRadius: '12px',
                    marginBottom: '24px',
                    border: '1px solid rgba(231, 76, 60, 0.3)',
                    boxShadow: '0 4px 12px rgba(231, 76, 60, 0.08)'
                  }}
                >
                  <p style={{
                    margin: 0,
                    color: '#c62828',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                    lineHeight: '1.6'
                  }}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ minWidth: '18px', marginTop: '1px' }}>
                      <path
                        d="M9 5V9M9 13H9.01M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
                        stroke="#c62828"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{tr("maximum5WatchlistsAllowedDetailed")}</span>
                  </p>
                </div>
              )}

              {/* Premium Input field */}
              <div style={{ marginBottom: '24px' }}>
                <label
                  htmlFor="watchlistNameInputHeader"
                  style={{
                    display: 'block',
                    marginBottom: '10px',
                    fontWeight: '600',
                    fontSize: '14px',
                    color: '#1a1a1a',
                    letterSpacing: '-0.2px'
                  }}
                >
                  {tr("watchlistName")} <span style={{ color: '#D67A1F', marginLeft: '2px' }}>*</span>
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    id="watchlistNameInputHeader"
                    className="form-control"
                    placeholder={tr("watchlistNamePlaceholder")}
                    value={newWatchlistName}
                    onChange={(e) => {
                      setNewWatchlistName(e.target.value);
                      setWatchlistError('');
                    }}
                    maxLength={30}
                    disabled={headerUserWatchlists.length >= 5}
                    style={{
                      padding: '14px 16px',
                      fontSize: '14px',
                      border: watchlistError ? '2px solid #ef5350' : '2px solid #e0e7ef',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#1a1a1a',
                      transition: 'all 0.3s',
                      outline: 'none',
                      fontWeight: '500'
                    }}
                    onFocus={(e) => {
                      if (!watchlistError) {
                        e.target.style.border = '2px solid #2457BF';
                        e.target.style.boxShadow = '0 0 0 4px rgba(36, 87, 191, 0.1)';
                      }
                    }}
                    onBlur={(e) => {
                      if (!watchlistError) {
                        e.target.style.border = '2px solid #e0e7ef';
                        e.target.style.boxShadow = 'none';
                      }
                    }}
                  />
                </div>

                {/* Character counter - Premium */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '8px',
                  fontSize: '12px',
                  color: '#64748b',
                  fontWeight: '500'
                }}>
                  <span style={{
                    color: newWatchlistName.length >= 25 ? '#D67A1F' : '#64748b'
                  }}>
                    {newWatchlistName.length}/30 {tr("characters")}
                  </span>
                  {newWatchlistName.length >= 25 && (
                    <span style={{ color: '#D67A1F', fontSize: '11px' }}>
                      {30 - newWatchlistName.length} {tr("remaining")}
                    </span>
                  )}
                </div>

                {/* Error message - Premium */}
                {watchlistError && (
                  <div style={{
                    color: '#c62828',
                    fontSize: '13px',
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 12px',
                    backgroundColor: '#fff5f5',
                    borderRadius: '8px',
                    border: '1px solid rgba(231, 76, 60, 0.2)'
                  }}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M8 4V8M8 12H8.01M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
                        stroke="#c62828"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{watchlistError}</span>
                  </div>
                )}
              </div>

              {/* Quick suggestions - Premium Design */}
              {headerUserWatchlists.length < 5 && (
                <div style={{ marginBottom: '24px' }}>
                  <p style={{
                    fontSize: '13px',
                    color: '#64748b',
                    marginBottom: '12px',
                    fontWeight: '600',
                    letterSpacing: '-0.1px'
                  }}>
                    {tr("quickSuggestions")}
                  </p>
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '10px'
                  }}>
                    {['Second Watchlist', 'Third Watchlist', 'Fourth Watchlist', 'Fifth Watchlist']
                      .filter(suggestion => !headerUserWatchlists.includes(suggestion))
                      .slice(0, 5 - headerUserWatchlists.length)
                      .map((suggestion, index) => (
                        <button
                          key={index}
                          type="button"
                          onClick={() => setNewWatchlistName(suggestion)}
                          style={{
                            padding: '8px 16px',
                            fontSize: '13px',
                            fontWeight: '500',
                            backgroundColor: '#ffffff',
                            color: '#2457BF',
                            border: '1.5px solid #e0e7ef',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            letterSpacing: '-0.1px'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#2457BF';
                            e.target.style.color = '#ffffff';
                            e.target.style.borderColor = '#2457BF';
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 4px 12px rgba(36, 87, 191, 0.2)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#ffffff';
                            e.target.style.color = '#2457BF';
                            e.target.style.borderColor = '#e0e7ef';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = 'none';
                          }}
                        >
                          {suggestion}
                        </button>
                      ))
                    }
                  </div>
                </div>
              )}

              {/* Current watchlists count - Premium Card */}
              <div style={{
                fontSize: '13px',
                color: '#334155',
                padding: '16px 18px',
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                border: '1px solid #e0e7ef',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: headerUserWatchlists.length > 0 ? '12px' : '0'
                }}>
                  <strong style={{ fontSize: '14px', color: '#1a1a1a' }}>{tr("yourWatchlists")}</strong>
                  <span
                    style={{
                      padding: '4px 12px',
                      backgroundColor: headerUserWatchlists.length >= 5 ? '#fff5f5' : '#f0f9ff',
                      color: headerUserWatchlists.length >= 5 ? '#c62828' : '#2457BF',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}
                  >
                    {headerUserWatchlists.length}/5
                  </span>
                </div>
                {headerUserWatchlists.length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {headerUserWatchlists.map((name, index) => (
                      <span
                        key={index}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '6px 12px',
                          backgroundColor: '#F2F7FD',
                          color: '#334155',
                          borderRadius: '6px',
                          fontSize: '12px',
                          fontWeight: '500',
                          border: '1px solid #e0e7ef'
                        }}
                      >
                        <span style={{
                          width: '6px',
                          height: '6px',
                          backgroundColor: '#2457BF',
                          borderRadius: '50%',
                          marginRight: '8px'
                        }}></span>
                        {name}
                      </span>
                    ))}
                  </div>
                )}
              </div>

            </div>

            {/* Premium Footer */}
            <div
              className="modal-footer"
              style={{
                borderTop: '1px solid #e0e7ef',
                padding: '20px 28px',
                backgroundColor: '#ffffff',
                display: 'flex',
                gap: '12px'
              }}
            >
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancelCreateWatchlist}
                style={{
                  padding: '11px 24px',
                  fontSize: '14px',
                  fontWeight: '600',
                  backgroundColor: '#f1f5f9',
                  color: '#475569',
                  border: 'none',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  letterSpacing: '-0.2px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#e2e8f0';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                {tr("cancel")}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCreateWatchlistHeaderAndAddToWatchlist}
                disabled={headerUserWatchlists.length >= 5 || !newWatchlistName.trim()}
                style={{
                  padding: '11px 24px',
                  fontSize: '14px',
                  fontWeight: '600',
                  background: (headerUserWatchlists.length >= 5 || !newWatchlistName.trim())
                    ? '#cbd5e1'
                    : 'linear-gradient(135deg, #2457BF 0%, #1a42a0 100%)',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  cursor: (headerUserWatchlists.length >= 5 || !newWatchlistName.trim()) ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s',
                  letterSpacing: '-0.2px',
                  boxShadow: (headerUserWatchlists.length >= 5 || !newWatchlistName.trim())
                    ? 'none'
                    : '0 4px 12px rgba(36, 87, 191, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  if (!(headerUserWatchlists.length >= 5 || !newWatchlistName.trim())) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(36, 87, 191, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!(headerUserWatchlists.length >= 5 || !newWatchlistName.trim())) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(36, 87, 191, 0.3)';
                  }
                }}
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M7 2V12M2 7H12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {tr("createWatchlist")}
              </button>
            </div>

          </div>
        </div>
      </div>







      {/* MarketDepth Modal */}
      {/* Market Depth Popover */}
      {showMarketDepth && (
        <div
          ref={marketDepthPopoverRef}
          style={{
            position: "fixed",
            top: `${marketDepthPosition.top}px`,
            left: `${marketDepthPosition.left}px`,
            zIndex: 9999,
            width: "480px",
            maxHeight: "calc(100vh - 100px)",
            overflowY: "auto",
            overflowX: "hidden",
            backgroundColor: "#FFFFFF",
            borderRadius: "16px",
            boxShadow:
              "0 20px 60px rgba(0, 0, 0, 0.2), 0 0 1px rgba(0, 0, 0, 0.1)",
            animation: "fadeInScale 0.2s ease-out",
          }}
        >
          {/* Arrow pointing to button */}
          <div
            style={{
              position: "absolute",
              right: "-8px",
              top: "30px",
              width: 0,
              height: 0,
              borderTop: "8px solid transparent",
              borderBottom: "8px solid transparent",
              borderLeft: "8px solid #2B54A8",
            }}
          ></div>

          {/* Header with gradient */}
          <div
            style={{
              background: "linear-gradient(135deg, #2457BF 0%, #1a42a0 100%)",
              padding: "1.25rem 1.5rem",
              position: "relative",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5
              style={{
                color: "#FFFFFF",
                fontSize: "1rem",
                fontWeight: 700,
                letterSpacing: "-0.02em",
                margin: 0,
              }}
            >
              {tr("marketDepth")}
            </h5>
            <button
              onClick={handleModalClose}
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                border: "none",
                borderRadius: "6px",
                width: "28px",
                height: "28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s",
                flexShrink: 0,
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(255, 255, 255, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "rgba(255, 255, 255, 0.2)";
              }}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                  d="M1 1L13 13M13 1L1 13"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>

          <div style={{ padding: "1.25rem" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                border: "1px solid #E8EAED",
              }}
            >
              <table
                style={{
                  backgroundColor: "#FFFFFF",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th
                      colSpan="3"
                      style={{
                        background:
                          "linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%)",
                        color: "#059669",
                        fontSize: "0.65rem",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        padding: "0.75rem 0.4rem",
                        borderBottom: "2px solid #059669",
                        borderRight: "1px solid #E8EAED",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.3rem",
                        }}
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M8 12V4M8 4L4 8M8 4L12 8"
                            stroke="#059669"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>{tr("bid")}</span>
                      </div>
                    </th>
                    <th
                      colSpan="3"
                      style={{
                        background:
                          "linear-gradient(135deg, #FEF2F2 0%, #FECACA 100%)",
                        color: "#DC2626",
                        fontSize: "0.65rem",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        padding: "0.75rem 0.4rem",
                        borderBottom: "2px solid #DC2626",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.3rem",
                        }}
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M8 4V12M8 12L12 8M8 12L4 8"
                            stroke="#DC2626"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>{tr("ask")}</span>
                      </div>
                    </th>
                  </tr>
                  <tr style={{ backgroundColor: "#F8F9FB" }}>
                    <th
                      style={{
                        fontSize: "0.6rem",
                        fontWeight: 600,
                        color: "#374151",
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        padding: "0.6rem 0.25rem",
                        borderBottom: "1px solid #E8EAED",
                        borderRight: "1px solid #E8EAED",
                        textAlign: "center",
                        width: "16.66%",
                      }}
                    >
                      {tr("qtyShort")}
                    </th>
                    <th
                      style={{
                        fontSize: "0.6rem",
                        fontWeight: 600,
                        color: "#374151",
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        padding: "0.6rem 0.25rem",
                        borderBottom: "1px solid #E8EAED",
                        borderRight: "1px solid #E8EAED",
                        textAlign: "center",
                        width: "16.66%",
                      }}
                    >
                      {tr("price")}
                    </th>
                    <th
                      style={{
                        fontSize: "0.6rem",
                        fontWeight: 600,
                        color: "#374151",
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        padding: "0.6rem 0.25rem",
                        borderBottom: "1px solid #E8EAED",
                        borderRight: "1px solid #E8EAED",
                        textAlign: "center",
                        width: "16.66%",
                      }}
                    >
                      {tr("ord")}
                    </th>
                    <th
                      style={{
                        fontSize: "0.6rem",
                        fontWeight: 600,
                        color: "#374151",
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        padding: "0.6rem 0.25rem",
                        borderBottom: "1px solid #E8EAED",
                        borderRight: "1px solid #E8EAED",
                        textAlign: "center",
                        width: "16.66%",
                      }}
                    >
                      {tr("qtyShort")}
                    </th>
                    <th
                      style={{
                        fontSize: "0.6rem",
                        fontWeight: 600,
                        color: "#374151",
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        padding: "0.6rem 0.25rem",
                        borderBottom: "1px solid #E8EAED",
                        borderRight: "1px solid #E8EAED",
                        textAlign: "center",
                        width: "16.66%",
                      }}
                    >
                      {tr("price")}
                    </th>
                    <th
                      style={{
                        fontSize: "0.6rem",
                        fontWeight: 600,
                        color: "#374151",
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        padding: "0.6rem 0.25rem",
                        borderBottom: "1px solid #E8EAED",
                        textAlign: "center",
                        width: "16.66%",
                      }}
                    >
                      {tr("ord")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {(() => {
                    const filteredMarketDepth = Array.isArray(marketDepth)
                      ? marketDepth
                      : [];

                    const bids = filteredMarketDepth.filter(
                      (d) => d.BbBuySellFlag === 66,
                    );
                    const asks = filteredMarketDepth.filter(
                      (d) => d.BbBuySellFlag !== 66,
                    );

                    return [...Array(5)].map((_, i) => {
                      const bid = bids[i] || {
                        Quantity: 0,
                        Price: 0,
                        NumberOfOrders: 0,
                      };
                      const ask = asks[i] || {
                        Quantity: 0,
                        Price: 0,
                        NumberOfOrders: 0,
                      };

                      return (
                        <tr
                          key={i}
                          style={{
                            transition: "all 0.2s ease",
                            borderBottom: i < 4 ? "1px solid #F3F4F6" : "none",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#F9FAFB";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                              "transparent";
                          }}
                        >
                          <td
                            style={{
                              fontWeight: 600,
                              color: "#059669",
                              fontSize: "0.75rem",
                              padding: "0.6rem 0.25rem",
                              borderRight: "1px solid #F3F4F6",
                              backgroundColor: "rgba(5, 150, 105, 0.02)",
                              textAlign: "center",
                            }}
                          >
                            {bid.Quantity ? bid.Quantity.toLocaleString("en-IN") : "0"}
                          </td>
                          <td
                            style={{
                              fontWeight: 600,
                              color: "#059669",
                              fontSize: "0.8rem",
                              padding: "0.6rem 0.25rem",
                              borderRight: "1px solid #F3F4F6",
                              backgroundColor: "rgba(5, 150, 105, 0.04)",
                              textAlign: "center",
                            }}
                          >
                            {bid.Price ? bid.Price.toFixed(2) : "0.00"}
                          </td>
                          <td
                            style={{
                              fontWeight: 600,
                              color: "#059669",
                              fontSize: "0.7rem",
                              padding: "0.6rem 0.25rem",
                              backgroundColor: "rgba(5, 150, 105, 0.02)",
                              textAlign: "center",
                            }}
                          >
                            <span
                              style={{
                                backgroundColor: "#ECFDF5",
                                padding: "0.15rem 0.2rem",
                                borderRadius: "4px",
                                fontSize: "0.6rem",
                                fontWeight: 700,
                                display: "inline-block",
                              }}
                            >
                              {bid.NumberOfOrders > 0 ? bid.NumberOfOrders : "0"}
                            </span>
                          </td>
                          <td
                            style={{
                              fontWeight: 600,
                              color: "#DC2626",
                              fontSize: "0.75rem",
                              padding: "0.6rem 0.25rem",
                              borderRight: "1px solid #F3F4F6",
                              backgroundColor: "rgba(220, 38, 38, 0.02)",
                              textAlign: "center",
                            }}
                          >
                            {ask.Quantity ? ask.Quantity.toLocaleString("en-IN") : "0"}
                          </td>
                          <td
                            style={{
                              fontWeight: 600,
                              color: "#DC2626",
                              fontSize: "0.8rem",
                              padding: "0.6rem 0.25rem",
                              borderRight: "1px solid #F3F4F6",
                              backgroundColor: "rgba(220, 38, 38, 0.04)",
                              textAlign: "center",
                            }}
                          >
                            {ask.Price ? ask.Price.toFixed(2) : "0.00"}
                          </td>
                          <td
                            style={{
                              fontWeight: 600,
                              color: "#DC2626",
                              fontSize: "0.7rem",
                              padding: "0.6rem 0.25rem",
                              backgroundColor: "rgba(220, 38, 38, 0.02)",
                              textAlign: "center",
                            }}
                          >
                            <span
                              style={{
                                backgroundColor: "#FEF2F2",
                                padding: "0.15rem 0.2rem",
                                borderRadius: "4px",
                                fontSize: "0.6rem",
                                fontWeight: 700,
                                display: "inline-block",
                              }}
                            >
                              {ask.NumberOfOrders > 0 ? ask.NumberOfOrders : "0"}
                            </span>
                          </td>
                        </tr>
                      );
                    });
                  })()}
                </tbody>
              </table>
            </div>

            {/* Info footer */}
            <div
              style={{
                marginTop: "1rem",
                padding: "0.75rem 1rem",
                backgroundColor: "#F8F9FB",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "0.65rem",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <div
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#059669",
                  }}
                ></div>
                <span
                  style={{
                    color: "#6B7280",
                    fontWeight: 600,
                  }}
                >
                  {tr("buy")}
                </span>
              </div>
              <div
                style={{
                  color: "#9CA3AF",
                  fontWeight: 500,
                }}
              >
                {tr("liveData")}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <div
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#DC2626",
                  }}
                ></div>
                <span
                  style={{
                    color: "#6B7280",
                    fontWeight: 600,
                  }}
                >
                  {tr("sell")}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}



      {/* CDSL Authorization Modal */}

      <button
        id="openCDSLModalBtn"
        type="button"
        class="d-none"
        data-bs-toggle="modal"
        data-bs-target="#CDSLAuthorizationModal"
      ></button>



      <div
        className="modal fade"
        id="CDSLAuthorizationModal"
        aria-labelledby="CDSLAuthorizationModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div
            className="modal-content shadow-lg rounded-4"
            style={{
              backgroundColor: '#ffffffff',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              border: "2px solid #ff6b35"
            }}
          >

            <div className="modal-header pb-0" style={{ borderBottom: "2px solid #ff6b35" }}>
              <h5
                className="modal-title"
                id="CDSLAuthorizationModalLabel"
                style={{
                  color: '#212529',
                  fontWeight: '700',
                  fontSize: '1.5rem',
                  paddingBottom: "12px"
                }}
              >
                {tr("authorizeCDSLAccess")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label={tr("close")}
                style={{ filter: 'brightness(0.5)' }}
              />
            </div>

            <div className="modal-body py-4 text-center" style={{ color: '#2e3031ff' }}>
              <div className="mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="64"
                  fill="#ff6b35"
                  className="bi bi-shield-lock"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                  <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z" />
                </svg>
              </div>

              <h3 style={{ fontWeight: '600', marginBottom: '1rem', color: '#212529' }}>
                {tr("cdslSellAuthorizationRequired")}
              </h3>

              <p style={{ fontSize: '1.05rem', marginBottom: '2rem', lineHeight: '1.6' }}>
                {tr("cdslAuthorizationDescription")}
              </p>

              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary px-4 py-2 fw-semibold"
                  data-bs-dismiss="modal"
                  style={{
                    borderRadius: '30px',
                    fontSize: '1rem',
                    letterSpacing: '0.03em'
                  }}
                >
                  {tr("cancel")}
                </button>

                <form
                  name="CDSLAuthForm"
                  method="post"
                  action="https://dev-openapi.5paisa.com/WebVendorLogin/EDISAuthorization/Authorization"
                  target="_blank"
                  style={{ margin: 0 }}
                >
                  <input
                    type="hidden"
                    name="AccessToken"
                    value={sharedData?.accessToken || ""}
                  />
                  <input
                    type="hidden"
                    name="ClientCode"
                    value={sharedData?.ClientCode || ""}
                  />
                  <input
                    type="hidden"
                    name="VendorKey"
                    value={sharedData?.api_key || ""}
                  />
                  <input
                    type="hidden"
                    name="ResponseURL"
                    value={`https://beta.infomanav.in/zerodhaReact/authorization/${sharedData?.ID || ""}`}
                  />

                  <button
                    type="submit"
                    className="btn px-4 py-2 fw-semibold"
                    style={{
                      borderRadius: '30px',
                      fontSize: '1rem',
                      letterSpacing: '0.03em',
                      backgroundColor: '#ff6b35',
                      color: 'white',
                      border: 'none'
                    }}
                    data-bs-dismiss="modal"
                  >
                    {tr("authorize")}
                  </button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>






    </>
  );
};

export default Header;




